<template>
  <div class="main">
    <van-sticky>
      <div class="name">
        <div style="width: 20%;height: 12rem;">
          <img v-if="packageDetail && packageDetail.packageName" :src='packageDetail | picFilter' width="100%"
               height="100%"
               style="border-radius: 1rem;">
        </div>
        <div style="width: 80%;display: flex;flex-flow: row;">
          <div style="width: 90%;display: flex;flex-flow: column;justify-content: center;">
            <span
                style="font-size: 2.8rem;font-weight: 700;color: #171A32;margin-left: 2rem;">{{
                packageDetail.packageName
              }}</span>
            <span style="font-size: 2.3rem;color: #898989;padding-left: 1em;
                                  word-break: break-all;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  display: -webkit-box;
                                  text-overflow: ellipsis;
                                  -webkit-box-orient: vertical;
                                  -webkit-line-clamp: 2;"
                  @click="showDescription=true">
                    推荐人群：{{ packageDetail.description }}
                    </span>

          </div>
        </div>
      </div>
    </van-sticky>
    <!--套餐详情层-->
    <van-popup close-icon="close" closeable v-model="showDescription"
               round position="bottom" :style="{ height: '90%' }">
      <div style="width: 100%;height: 7%"></div>
      <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
        <span style="font-size: 3rem;margin-left: 2rem;">{{ packageDetail.packageName }}</span>
        <span style="font-size: 2.3rem;color: #898989;padding: 1em;color: #576b95;">{{
            packageDetail.description
          }}</span>
      </div>
    </van-popup>
    <div style="margin-top: 1.5rem;width: 100%;display: flex;flex-flow: row;margin-bottom: 1.5rem;
    align-items: center;justify-content: space-around;font-size: 2.2rem;color: #409EFF;">
      <div>
        <img src="@/assets/images/safe.svg" style="width: 2.2rem;height: 2.2rem;margin-top: 0.6rem;">
        <span style="margin-left: 0.5rem;">随时退</span>
      </div>
      <div>
        <img src="@/assets/images/safe.svg" style="width: 2.2rem;height: 2.2rem;margin-top: 0.6rem;">
        <span style="margin-left: 0.5rem;">随时改</span>
      </div>
      <div>
        <img src="@/assets/images/safe.svg" style="width: 2.2rem;height: 2.2rem;margin-top: 0.6rem;">
        <span style="margin-left: 0.5rem;">电子报告</span>
      </div>
      <div>
        <img src="@/assets/images/safe.svg" style="width: 2.2rem;height: 2.2rem;margin-top: 0.6rem;">
        <span style="margin-left: 0.5rem;">专家解读</span>
      </div>
    </div>
    <div v-if="userInfo.name">
      <div style="width: 100%;margin-top: 0.5rem;">
        <van-field center name="radio" label="本人" label-width="8rem">
          <template #input>
            <van-radio-group v-model="radio" direction="horizontal" @change="changeUser">
              <van-radio icon-size="16px" :name="userInfo.cardid" v-if="userInfo.cardid">
                {{ userInfo.name | nameFilter }} | {{ userInfo.sexid | sexFilter }} |
                {{ userInfo.cardid | hideCardIdStr }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="亲属" label-width="8rem" v-if="relatives.length > 0">
          <template #input>
            <van-radio-group v-model="radio" @change="changeUser">
              <van-radio icon-size="16px" style="margin-bottom: 1rem;" :name="item.cardid"
                         v-for="item in relatives" v-bind:key="'relatives' + item.name">
                {{ item.name | nameFilter }} | {{ item.sexid | sexFilter }} | {{ item.cardid | hideCardIdStr }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
    </div>
    <!--预约日期选择-->
    <dl class="order-dates">
      <dt><h3>可约体检日期</h3>
        <div class="dt-right" @click="showDate = true">全部日期
          <van-icon name="arrow"/>
        </div>
      </dt>
      <dd>
        <ul>
          <li :v-if="orderWeektime.length > 0" v-for="(item,index) in orderWeektime"
              v-bind:key="'orderWeektime' + index"
              :class="{'disabled':item.type,active:item.date == checkDate,actived:item.date == checkedDate}"
              @click="selectWeekDate(item)">
            <p class="day">{{ item.day }}<em v-if="item.isFestival" class="sup">{{ item.festivalName }}</em></p>
            <p class="week">{{ item.week }}</p>
            <p class="number">{{ item.number }}</p>
          </li>
        </ul>
        <p style="text-align: center;color: #ff976a;font-size: 2rem">{{ festivalTips }}</p>
      </dd>
    </dl>
    <div class="order-times" v-if="setBookedTime.length > 0">
      <h3>预约时间段</h3>
      <van-radio-group v-model="setBookedTimeSelected">
        <van-cell-group>
          <van-cell v-for="(item,index) in setBookedTime" v-bind:key="'setBookedTime' + index"
                    :title="item | setBookedTimeFilter"
                    clickable
                    @click="setBookedTimeClick(item)"
                    :value="item.surplus<=0?'已约满':'可约 ' + item.surplus"
                    value-class="pdr10"
                    title-style="font-weight:700"
          >
            <template #right-icon>
              <van-radio :name="item.id" :disabled="item.surplus<=0"/>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div style="margin-top: 0.5rem;">
      <van-tabs @click="onClick" color="#409EFF" v-model="active">
        <van-tab title="套餐详情"></van-tab>
        <van-tab title="加做项目"></van-tab>
        <van-tab title="预约须知"></van-tab>
        <van-tab title="体检须知"></van-tab>
      </van-tabs>
    </div>
    <div style="padding-bottom: 15rem;">
      <div class="group" v-if="active == 0" style="padding-bottom: 14rem;">
        <div
            style="width:100%;height: 40px;display: flex;align-items: center;margin-left: 10px;font-size: 2.3rem;font-weight: 500;">
          <div style="width: 3px;height: 40%;background: #409EFF"></div>
          <span style="margin-left: 6px;">体检项目（{{ total }}项）</span>
        </div>
        <div v-for="(item,index) in packageDetail.basicGroupInfos" v-bind:key="'basicGroupInfos' + index">
          <van-cell v-if="packageItemDec && !projectDetailShow" center style="border-bottom: 1px solid #f5f0f0;"
                    :title=" (index + 1) + '、' + item.groupName"
                    :label="item.clinicalSignIficance | valueFilter"/>
          <van-cell v-if="!packageItemDec && !projectDetailShow" center style="border-bottom: 1px solid #f5f0f0;"
                    :title=" (index + 1) + '、' + item.groupName"
          />
          <!--     项目详情以弹窗的方式显示     -->
          <div v-if="projectDetailShow" style="display: flex;flex-direction: row;justify-content: space-between;">
            <span style="width: 80%">
               <van-cell center style="border-bottom: 1px solid #f5f0f0;" :title=" (index + 1) + '、' + item.groupName"/>
            </span>
            <span class="project_detal_show" @click="showProjectDetail(item.clinicalSignIficance)">
             {{ item.clinicalSignIficance != '' ? '检查意义> ' : ' ' }}
            </span>
          </div>
        </div>
      </div>
      <div class="group" style="width: 92%;margin-top: 1rem;padding-bottom: 5rem;" v-if="active == 1">
        <van-cell-group>
          <van-cell v-for="(item,index)  in checkedGroups" v-bind:key="'checkedGroups1-' + index"
                    :title="(index + 1)+ '、' +item.groupName" center>
            <template #right-icon>
              <img src="@/assets/images/del.svg" style="width: 20px;height: 25px;"
                   @click="delGroup(item.groupId,item.groupName,item.actualPrice)">
            </template>
          </van-cell>
        </van-cell-group>
        <van-empty v-if="checkedGroups.length == 0" description="没有加做项目"/>
      </div>
      <div class="group" v-if="active == 2"
           style="color:#646566;font-size: 2.3rem;display: flex;flex-flow: column;align-items: center;padding-bottom: 5rem;">
        <html-panel :url="orderNoticeUrl"></html-panel>
      </div>
      <div class="group" v-if="active == 3"
           style="padding-bottom: 10rem;color:#646566;font-size: 2.3rem;display: flex;flex-flow: column;align-items: center;background: #fff;margin-top: 1rem;">
        <html-panel :url="getPageUrl"></html-panel>
      </div>
    </div>

    <!--底部按钮及金额显示-->
    <van-goods-action>
      <div class="van-goods-price">
        <span class="goods-price-text">合计：</span>&yen;<span
          class="goods-price-int">{{ selfAmount.toFixed(2).split('.')[0] }}</span>.
        <span class="goods-price-float">{{ selfAmount.toFixed(2).split('.')[1] }}</span>
        <span v-if="discountamount!=0"
              style="display:block;margin-left: 3em;color: #999">已优惠 {{ Math.abs(discountamount.toFixed(2)) }}</span>
      </div>
      <van-badge v-if="VUE_APP_ENABEL_SPECIFICDISEASE" :content="checkedPackages.length<=0?0:checkedPackages.length - 1"
                 max="9" style="z-index:9">
        <van-goods-action-button class="child" style="padding: 0 1em" type="warning" text="专病套餐"
                                 @click="showSpecificDiseasePop" color="linear-gradient(to right, #10E3E9, #409EFF)"/>
      </van-badge>

      <van-badge v-if="orderAddItem" :content="checkedGroups.length" max="99" style="z-index:8">
        <van-goods-action-button class="child" style="padding: 0 1em" type="warning" text="加项"
                                 color="linear-gradient(to right, #10E3E9, #409EFF)" @click="plusItem" icon="plus"/>
      </van-badge>
      <van-goods-action-button type="danger" text="立即预约" @click="checkInfo"
                               color="linear-gradient(to right, #E6A23C, #F56C6C)"/>
    </van-goods-action>

    <!--预约日期选择日历层-->
    <van-calendar v-model="showDate" confirm-text="选 择" title="选择体检日期" :min-date="minDate" :max-date="maxDate"
                  @confirm="selectDate" :formatter="formatter" color="#1989fa" ref="allDate"/>
    <!-- 自选项目模块 -->
    <van-popup v-model="showAdd" round position="bottom" :style="{ height: '90%',overflow:'hidden' }">
      <div
          style="width: 100%;height: 88%;padding-bottom: 12rem;display: flex;flex-flow: row;justify-content: space-around;">
        <div style="width: 30%;height: 100%;overflow-y: scroll;" class="plur-item-side">
          <van-cell-group v-for="value in deptArr" v-bind:key="'dep-' + value" :border="false"
                          v-bind:class="{ active: value == checkDeptStr }">
            <div class="corner top-corner"></div>
            <van-cell :title="value" @click="checkDept(value)"/>
            <div class="corner bottom-corner"></div>
          </van-cell-group>
        </div>
        <div style="width: 68%;height: 100%;overflow-y: scroll;background: #fff;
        display: flex;flex-flow: column;overflow-x: hidden" class="plur-item-main">
          <van-checkbox-group v-model="result">
            <van-cell-group>
              <van-cell
                  :name="value.groupId" v-for="(value) in groups"
                  v-bind:key="'groups' + value.groupId"
                  :title="value.groupName"
                  :label="value.clinicalSignIficance"
                  :style="{color:disableGroup.includes(value.groupId)?'#c8c9cc':'initial'}"
                  style="font-weight: 700"
              >
                <template #right-icon>
                  <van-checkbox icon-size="18px" @click="checkGroup(value.groupId,value.groupName)"
                                :name="value.groupId"
                                :disabled="disableGroup.includes(value.groupId)"
                                style="margin-right: 1rem;"/>
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
      </div>
      <van-goods-action>
        <div class="van-goods-price">
          <span class="goods-price-text">合计：</span>&yen;<span
            class="goods-price-int">{{ selfAmount.toFixed(2).split('.')[0] }}</span>.
          <span class="goods-price-float">{{ selfAmount.toFixed(2).split('.')[1] }}</span>
        </div>
        <van-goods-action-button type="warning" text="关 闭" @click="showAdd=false"
                                 color="linear-gradient(to right, #10E3E9, #409EFF)"/>
        <van-goods-action-button type="warning" text="清空已选" @click="clearGroups"
                                 color="linear-gradient(to right, #E6A23C, #F56C6C)"/>
        <van-badge :content="checkedGroups.length" max="99" style="z-index:8;margin-right: 1.5em">
          <van-goods-action-button class="child" style="padding: 0 1em" type="warning" text="已选加项"
                                   @click="showChecked"
                                   color="linear-gradient(to right, #BE99FF, #7232DD)"/>
        </van-badge>
      </van-goods-action>
    </van-popup>
    <!-- 专病套餐 -->
    <van-popup v-model="showSpecificDisease" round position="bottom"
               :style="{ height: '80%',overflowY:'auto',paddingBottom:'100px' }">
      <div
          style="width: 100%;padding-bottom: 12rem;display: flex;flex-flow:column; justify-content:flex-start;">
        <h3 class="van-hairline--bottom" style="font-size: 2.2em;text-align: center;line-height: 3em;color: #999;">
          选择专病套餐</h3>
        <van-field name="checkbox" v-for="(item,index) in SpecificDiseaseList"
                   v-bind:key="'SpecificDiseaseList' + index" style="min-height: 7em;">
          <template #input>
            <div class="package-item" @click="showSpecificDiseaseDetail(item)">
              <div style="width:50px;height: 100%;padding: 10px;display: flex;">
                <img :src='item | picFilter' style="width: 50px;height: 50px;border-radius: 1rem;">
              </div>
              <div style="height: 100%;display: flex;flex-flow: column;justify-content: space-around;flex: 1">
                  <span style="font-weight: 700;font-size: 2.5rem;color:#171A32;">
                    {{ item.packageName }}
                  </span>

                <span style="font-size: 2.3rem;color: #898989;
                                  word-break: break-all;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  display: -webkit-box;
                                  text-overflow: ellipsis;
                                  -webkit-box-orient: vertical;
                                  -webkit-line-clamp: 2;">
                    {{ item.description }}
                    </span>


                <!--套餐+项目和套餐允许退项结算方式显示套餐实际金额，其他显示原价金额-->
                <span v-if="showMoney" style="font-size:2.4rem;color: #F56C6C;">￥{{ item.actualPrice }}</span>
                <div style="width: 100%;display: flex;justify-content:flex-start;align-items: center;">
                  <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '1'">男性</van-tag>
                  <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '2'">女性</van-tag>
                  <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '0'">通用</van-tag>
                </div>
              </div>
            </div>
            <van-button style="width: 15%;display: flex;justify-content: center;color: #9DA3A7;border: none"
                        @click="checkSpecificDisease(item,$event)" :disabled="item.isSelected">
                <span>
<!--                  packageId-->
                  <van-icon name="add" size="4rem" v-if="!item.isSelected"/>
                  <van-icon name="checked" size="4rem" color="#c8c9cc" v-if="item.isSelected"/>
                </span>
            </van-button>
          </template>
        </van-field>
        <transition
            @before-enter="beforeEnter"
            @enter="enter"
            @after-enter="afterEnter"
        >
          <div class="ball" v-show="ball.show">
            <div class="innerBall">
              <van-image
                  width="4rem"
                  height="4rem"
                  :src="ball.imgSrc"
              />
            </div>
          </div>
        </transition>
      </div>
      <van-goods-action>
        <div class="van-goods-price">
          <span class="goods-price-text">合计：</span>&yen;<span
            class="goods-price-int">{{ selfAmount.toFixed(2).split('.')[0] }}</span>.
          <span class="goods-price-float">{{ selfAmount.toFixed(2).split('.')[1] }}</span>
        </div>
        <van-goods-action-button type="warning" text="关 闭" @click="showSpecificDisease=false"
                                 color="linear-gradient(to right, #10E3E9, #409EFF)"/>
        <van-goods-action-button type="warning" text="清空已选" @click="clearSpecificDisease"
                                 color="linear-gradient(to right, #E6A23C, #F56C6C)"/>
        <van-badge :content="checkedPackages.length<=0? 0 : checkedPackages.length - 1" max="9"
                   style="margin-right: 1em">
          <van-goods-action-button class="child" style="padding: 0 1em;" type="warning" text="已选专病"
                                   @click="showSpecificDiseaseChecked"
                                   color="linear-gradient(to right, #BE99FF, #7232DD)"/>
        </van-badge>
      </van-goods-action>
    </van-popup>
    <!--专病套餐详情-->
    <van-action-sheet
        v-model="specificDiseaseDetailShow"
        :title="specificDiseaseDetailTitle"
    >
      <div class="package-group-list" v-for="(item,index) in specificDiseaseDetail.basicGroupInfos"
           :key="'specificDiseaseDetail' + index">
        <dl class="van-hairline--bottom">
          <dt :class="item.isDelete == '2'?'text-decoration':''">{{ item.groupName }}</dt>
          <dd>{{ item.clinicalSignIficance }}</dd>
        </dl>
      </div>
    </van-action-sheet>
    <!--已选专病套餐浮窗-->
    <van-popup v-model="showCheckedPackages" round position="bottom" closeable
               :style="{ width: '100%',height:'60%'}">
      <van-empty v-if="checkedPackages.length <= 1" description="暂未选择专病套餐"/>
      <div v-if="checkedPackages.length > 1">
        <van-field name="checkbox" v-for="(item,index) in checkedPackages" v-bind:key="'checkedPackages' + index">
          <template #input v-if="item.packageType == '02'">
            <div class="package-item">
              <div style="width:50px;height: 100%;padding: 10px;display: flex;">
                <img :src='item | picFilter' style="width: 50px;height: 50px;border-radius: 1rem;">
              </div>
              <div style="height: 100%;display: flex;flex-flow: column;justify-content: space-around;flex: 1">
                  <span style="font-weight: 700;font-size: 2.5rem;color:#171A32;">
                    {{ item.packageName }}
                  </span>
                <span v-if="showMoney" style="font-size:2.4rem;color: #F56C6C;">￥{{ item.actualPrice }}
              </span>

                <div style="width: 100%;display: flex;justify-content:flex-start;align-items: center;">
                  <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '1'">男性</van-tag>
                  <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '2'">女性</van-tag>
                  <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '0'">通用</van-tag>

                </div>
              </div>
            </div>
            <van-button
                style="width: 15%;display: flex;justify-content: center;color: #9DA3A7;background:none;border: none;"
                @click="deleteSpecificDisease(item)" :disabled="item.modify == '0'?true:false">
              <span><van-icon name="clear" size="4rem" color="#ff6c6c"/></span>
            </van-button>
          </template>
        </van-field>
      </div>
      <van-empty v-if="checkedPackages.length == 0" description="没有已选套餐"/>
    </van-popup>
    <!--预约成功通知层-->
    <van-dialog v-model="showSuccess" theme="round-button" title="恭喜您，预约成功！" @confirm="toCheckInfo">
      <div style="width: 100%;display: flex;margin: 3rem 0;justify-content: center;">
        <div style="width: 90%;font-size: 2.5rem;">
          <p style="text-indent:2.5rem;">您的体检订单已经生效，请于 {{ checkDate }} 携带身份证前往 {{ hospitalAddress }}
            进行体检。</p>
        </div>
      </div>
    </van-dialog>
    <!--预约成功确认提交层-->
    <van-popup close-icon="close" closeable v-model="showTips" round position="bottom"
               :style="{ height: '75%',paddingTop:'3em',overflowY:'auto' }">
      <van-goods-action style="z-index: 9999">
        <van-goods-action-button type="danger" text="确认预约" @click="orderNow"
                                 color="linear-gradient(to right, #10E3E9, #409EFF)" :disabled="isSubmitting"
                                 :loading="isSubmitting" loading-text="提交中..."/>
      </van-goods-action>
      <!--已选全部套餐-->
      <div class="van-hairline--bottom" style="width: 98%;display: flex;flex-flow: row;margin-top:1em;"
           v-for="(item,index) in checkedPackages" :key="'checkedPackages1-' + index">
        <div style="width: 25%;height: 12rem;display: flex;align-items: center;justify-content: center;">
          <div style="width: 80%;height: 100%;display: flex;justify-content: center;align-items: center;">
            <img v-if="item.packageName" :src='item | picFilter' width="80%" height="80%" style="border-radius: 1rem;">
          </div>
        </div>
        <div style="width: 75%;display: flex;flex-flow: column;">
          <span style="font-size: 2.5rem;
           color: #333;margin-left: 2rem;">
            {{ item.packageName }}
          </span>
          <span style="margin-left: 2rem;font-size: 2.2rem;margin-top: 1rem;color: #666666;">
                <span
                    style="font-size: 2.5rem;margin-top: 1.5rem;color: #999;margin-right: 1rem; text-align: right;display: block"><em
                    style="font-size: .7em">&yen;</em>{{ item.actualPrice.toFixed(2) }}</span>
              </span>
        </div>
      </div>
      <!--加做项目-->
      <div class="van-hairline--bottom" style="width: 98%;display: flex;flex-flow: row;margin-top:1em;"
           v-for="(item,index) in checkedGroups" :key="'checkedGroups' + index">
        <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;padding-bottom: 1em;">
          <span style="font-size: 2.5rem;color: #333;margin-left: 2rem;">
            {{ item.groupName }}
          </span>
          <span style="font-size: 2.5rem;color: #999;margin-right: 1rem;"><em
              style="font-size: .7em">&yen;</em>{{ item.actualPrice.toFixed(2) }}
          </span>
        </div>
      </div>
      <!---->
      <div v-if="deductionAmount > 0" class="van-hairline--bottom"
           style="width: 98%;display: flex;flex-flow: row;margin-top:1em;">
        <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;padding-bottom: 1em;">
          <span style="font-size: 2.5rem;color: #333;margin-left: 2rem;">
            套餐重复项目
          </span>
          <span style="font-size: 2.5rem;color: #999;margin-right: 1rem;">- <em
              style="font-size: .7em">&yen;</em>{{ deductionAmount.toFixed(2) }}
          </span>
        </div>
      </div>

      <!--总计-->
      <div class="van-hairline--bottom" style="width: 98%;display: flex;flex-flow: row;margin-top:1em;">
        <div style="width: 100%;display: flex;flex-flow: row;justify-content:space-between;align-items: center;">
          <span style="font-size: 2.5rem;
           margin-left: 2rem;font-weight: 500">
            总计：
          </span>

          <span style="font-size: 2.5rem;color: orangered;margin-right: 1rem;"><em style="font-size: .7em">
            &yen;</em>
            <span class="goods-price-int" style="font-size:1.4em">{{ selfAmount.toFixed(2).split('.')[0] }}</span>.
            <span class="goods-price-float">{{ selfAmount.toFixed(2).split('.')[1] }}</span>
          </span>
        </div>
      </div>
      <div style="width: 100%;display: flex;flex-flow: column;margin-top: 1rem;">
        <van-cell-group v-if="discountamount!=0">
          <van-cell title="已优惠" :value="Math.abs(discountamount.toFixed(2))"/>
        </van-cell-group>
        <van-cell-group>
          <van-cell title="体检时间" :value="checkedDateText"/>
        </van-cell-group>
        <van-cell-group>
          <van-cell v-if="showTips" title="姓 名" :value="checkUser.name | nameFilter"/>
        </van-cell-group>
        <van-cell-group>
          <van-cell title="性 别" :value="checkUser.sexid | sexFilter"/>
        </van-cell-group>
        <van-cell-group>
          <van-cell v-if="checkUser.phone" title="手机号码" :value="checkUser.phone | hidePhoneStr"/>
        </van-cell-group>
        <van-cell-group>
          <van-cell title="出生日期" :value="checkUser.birthdate | birthFilter"/>
        </van-cell-group>
        <van-cell-group>
          <van-cell v-if="checkUser.cardid" title="身份证" :value="checkUser.cardid | hideCardIdStr"/>
        </van-cell-group>
      </div>
    </van-popup>
    <!--用户信息补全层-->
    <van-popup v-model="editUserShow"
               position="right" round
               :style="{ width: '100%', height:'100%',overflow:'hidden',backgroundColor:'#F2F2F2'}">
      <div style="width: 100%;">
        <van-notice-bar mode="closeable"
                        left-icon="volume-o"
                        text="尊敬的用户您好，请您补全身份证信息，这样我们才能提供更精准的服务！"
        />
      </div>
      <van-form style="width: 96%;margin-top: 1rem;" @submit="onSubmit">
        <van-field
            v-model="param.nickname"
            label="昵称"
            placeholder="昵称"/>
        <van-field required
                   v-model="param.name"
                   label="姓名（必填）"
                   placeholder="请填写身份证上的姓名"
                   :rules="[{ required: true, message: '请填写姓名' }]"/>
        <van-field name="radio" label="性别（必填）">
          <template #input>
            <van-radio-group v-model="param.sexid" direction="horizontal">
              <van-radio name="1">男</van-radio>
              <van-radio name="2">女</van-radio>
              <van-radio name="0">未说明</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field required
                   v-model="param.birthdate"
                   label="生日（必填）"
                   placeholder="生日"
                   @click="showAge = true"
                   disabled
                   :rules="[{ required: true, message: '请选择生日' }]"/>
        <van-field name="radio" label="婚姻（选填）">
          <template #input>
            <van-radio-group v-model="param.marital" direction="horizontal">
              <van-radio name="0">未婚</van-radio>
              <van-radio name="1">已婚</van-radio>
              <van-radio name="3">未说明</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-model="param.phone" v-if="type == 'editSelf'" :disabled="phoneDisabled"
                   type="tel"
                   label="手机号（必填）"
                   placeholder="手机号"
        />
        <van-field required v-model="param.cardid"
                   type="text"
                   label="身份证（必填）"
                   placeholder="身份证号"
                   :rules="[{ required: true, message: '请填写身份证号' }]"
                   :error-message="idcardErrorMessage"
                   @blur="idvalidate"
        />
        <van-field v-if="type == 'editSelf'"
                   v-model="param.password"
                   type="text"
                   name="密码"
                   label="密码（选填）"
                   placeholder="登录密码"
        />
        <van-field v-model="param.address" type="text" label="地址（选填）" placeholder="请填写现居住地址"/>
        <!--      <van-field v-model="param.natives" type="text" label="籍贯（选填）" placeholder="请选择籍贯" disabled-->
        <!--                 @click="showNative = true"/>-->
        <div class="footer">
          <van-button round block native-type="submit"
                      color="linear-gradient(to right, #10E3E9, #409EFF)"
                      style="margin-top: 5rem;">提 交
          </van-button>
        </div>
      </van-form>
    </van-popup>
    <!--订单层-->
    <van-popup v-model="chargeWrapperShow" position="bottom"
               :style="{ width: '100%', height:'100%',overflow:'hidden',backgroundColor:'#F2F2F2'}">
      <div style="text-align: center;">
        <van-icon name="success" size="40" color="#07c160"/>
        <h2 style="font-size: 3em;">预约成功</h2>
      </div>
      <div style="width: 100%;display: flex;margin: 3rem 0;justify-content: center;">
        <div style="width: 90%;font-size: 2.5rem;">
          <p style="text-indent:2.5rem;">您的体检订单已经生成，完成支付后，请于 {{ checkDate }} 携带身份证前往
            {{ hospitalAddress }} 进行体检。</p>
        </div>
      </div>
      <van-cell-group v-if="chargeWrapperData!=null && chargeWrapperData.ordermain">
        <van-cell title="付款金额" :value="chargeWrapperData.ordermain.ActualAmount"></van-cell>
        <van-cell title="订单号" :value="chargeWrapperData.ordermain.OrderNo"></van-cell>
        <van-cell title="项目标准金额" :value="chargeWrapperData.ordermain.Amount"></van-cell>
        <!--        <van-cell title="折扣" :value="chargeWrapperData.ordermain.Discount"></van-cell>-->
        <!--        <van-cell title="优惠" :value="chargeWrapperData.ordermain.DiscountAmount"></van-cell>-->
        <!--        <van-cell title="收费人" :value="chargeWrapperData.ordermain.ChargePeopleName"></van-cell>-->
        <!--        <van-cell title="收费时间" :value="chargeWrapperData.ordermain.Chargetime"></van-cell>-->
        <!--        <van-cell title="创建人" :value="chargeWrapperData.ordermain.OperatorIDName"></van-cell>-->
        <!--        <van-cell title="创建时间" :value="chargeWrapperData.ordermain.OperateDate"></van-cell>-->
      </van-cell-group>
      <van-empty v-if="chargeWrapperData==null || chargeWrapperData.ordermain == null || chargeWrapperData.httpstr==''"
                 :description="'调起支付失败，请联系' + hospitalPhone"/>
      <van-row style="margin:2em;">
        <van-col span="24">
          <!--          <van-button v-if="chargeWrapperData!=null && chargeWrapperData.httpstr!=null && chargeWrapperData.httpstr!=''" type="primary" round size="large" text="立即支付" :disabled="chargeWrapperData==null || chargeWrapperData.ordermain == null" :url="chargeWrapperData.httpstr"></van-button>-->
          <div class="vue-qr-code"
               v-if="chargeWrapperData!=null && chargeWrapperData.httpstr!=null && chargeWrapperData.httpstr!=''">
            <vue-qr :logoSrc="qrImageUrl" :text="chargeWrapperData.httpstr" :size="200"></vue-qr>
            <p class="vue-qr-text">长按二维码支付</p>
          </div>
        </van-col>
      </van-row>
    </van-popup>
    <!--支付轮询层-->
    <van-overlay :show="overayShow" class-name="overlay-interval">
      <div class="overlay-in">
        <div class="overlay-text">
          <p>预约成功</p>
          <p>
            <van-icon name="success" color="#1989fa"/>
          </p>
          <h3>正在发起支付...</h3>
          <p>请务操作！！！</p>
        </div>
        <van-circle v-model="currentRate" :rate="initRate" :speed="100" :text="circleText"
                    :stroke-width="30" size="120px" layer-color="#ebedf0" fill="#fff"/>
      </div>
    </van-overlay>
    <div class="vue-qr-code"
         v-if="chargeWrapperData!=null && chargeWrapperData.httpstr!=null && chargeWrapperData.httpstr!=''">
      <vue-qr :logoSrc="qrImageUrl" :text="chargeWrapperData.httpstr" :size="200"></vue-qr>
      <p class="vue-qr-text">长按二维码支付</p>
    </div>
    <div v-if="payLoading"
         style="display: flex;justify-content: center;align-items: center;z-index: 9999;width: 100%;height: 100%;position: absolute;top: 0;background-color: rgba(0,0,0,.7);">
      <van-loading size="24px" color="#fff" text-color="#fff">正在跳转支付...</van-loading>
    </div>
    <!--是否前往检前问卷导航菜单-->
    <van-popup v-if="goAnswerPopShow && answerShow" v-model="popIsQuestionOrOrder"
               position="top"
               :style="{ width: '100%', height:'100%',overflow:'hidden',backgroundColor:'#F2F2F2'}">
      <div
          style="display: flex;flex-direction: column; justify-content: center;align-content: center;margin:0 15%;height: 70%;">
        <van-button round type="primary" @click="toPreconsultation">填写检前问卷</van-button>
        <van-button v-if="!questionnaireMust" round type="info" style="margin-top: 1.2em;" @click="popIsQuestionOrOrder = false">进入体检预约
        </van-button>
      </div>
    </van-popup>
    <van-popup v-model="agreementCover" @click="agreementCover = false"
               position="bottom"
               :style="{ width: '100%', height:'100%',overflow:'hidden',backgroundColor:'#F2F2F2'}">
      <div class="wrapper" @click.stop>
        <letterConsentForm v-if="agreementCover" @update:agreementSave="handleSignatureIdUpdate"
                           :propsAgreementType="agreementType"></letterConsentForm>
      </div>
    </van-popup>
    <div v-if="payRefreshLoading"
         style="display: flex;justify-content: center;align-items: center;flex-direction: column;z-index: 9999;width: 100%;height: 100%;position: absolute;top: 0;background-color: hsla(0,0%,100%,.9);">
      <van-circle v-model="currentRate" :rate="endRate" :speed="100" :text="currentSecond + `秒`"/>
      <div style="font-size: 2em;margin-top: 1em;">后台正在处理...，请稍候</div>
    </div>

    <!--流程图提示框-->
    <van-dialog v-if=" flowChartISHOW" v-model="flowChart" theme="round-button" title="">
      <div class="badge-container">
        <img
            class="badge-image"
            :src="badgeImageUrl"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {HideCardIdStr, HidePhoneStr} from '@/assets/utils/utils.js'
import wxPay from '@/assets/utils/wxPay'
import {encrypt, decrypt} from '../../assets/utils/cryptoUtil.js'
import {transactions} from "@/api/module/auth";
import {Dialog, Toast} from 'vant';
import {
  getExcludeInfoList,
  getGroupInfoList,
  getPackageDetialByPackageId,
  getPackageListByCompanyId,
  getPaymentUrlByBookedNo, getPayStatus,
  getQuestionIsTrueForPersonal, getQuestionnaireTypeID
} from '@/api/module/index'
import {
  getRelatives,
  getUserInfoByPatientid,
  addOrder,
  getOrderCount,
  getSetBookedTime,
  editUserInfo, editRelatives, addRelatives,
  getOrderMain,
  sendHis
} from '@/api/module/user'
import HtmlPanel from "@/components/HtmlPanel";
import QRCode from "qrcodejs2";
import vueQr from 'vue-qr'
import {areaList} from "@vant/area-data";
import jse from '@/assets/utils/jsencryptKey'
import letterConsentForm from "@/views/letterConsentForm/index.vue";

export default {
  name: "index",
  components: {HtmlPanel, vueQr, letterConsentForm},
  filters: {
    valueFilter: function (value) {
      if (value == null || value == '') {
        return ''
      } else {
        return value
      }
    },
    nameFilter: function (value) {
      let val = decrypt(value)
      return val
    },
    sexFilter: function (value) {
      if (value == '2') {
        return '女'
      } else if (value == '1') {
        return '男'
      }
    },
    birthFilter: function (value) {
      if (value != null && value != "") {
        return value.substring(0, 10);
      } else {
        return "";
      }
    },
    setBookedTimeFilter: function (value) {
      return value.starttime + ' ~ ' + value.endtime
    },
    hideCardIdStr: function (value) {
      let val = decrypt(value)
      return HideCardIdStr(val)
    },
    hidePhoneStr: function (value) {
      let val = decrypt(value)
      return HidePhoneStr(val)
    }
  },
  data() {
    return {
      packageDetail: {},//体检套餐详情
      checkedPackages: new Array(),//已选套餐
      deductionAmount: 0,
      hospiatlname: window.g.VUE_APP_HOSPITALNAME,
      showMoney: window.g.VUE_APP_SHOW_MONEY,
      showOriginalMoney: window.g.VUE_APP_SHOW_ORIGINAL_MONEY,
      hisChargeOpen: window.g.VUE_APP_HIS_CHARGE_OPEN,
      VUE_APP_ISWECHAT: window.g.VUE_APP_ISWECHAT,
      VUE_APP_PAY_ENABLE: window.g.VUE_APP_PAY_ENABLE,
      VUE_APP_PAY_TYPE: window.g.VUE_APP_PAY_TYPE,
      hospitalPhone: window.g.VUE_APP_PHONE,
      hospitalAddress: window.g.VUE_APP_ADDRESS,
      getPageUrl: window.g.VUE_APP_SUB_DIR + '/HtmlPanels/notice_personal.html',
      orderNoticeUrl: window.g.VUE_APP_SUB_DIR + '/HtmlPanels/order_notice_personal.html',
      enterqueue: window.g.VUE_APP_DEFAULT_CHECKLINE,
      orderAddItem: window.g.VUE_APP_ORDER_ADDITEM,
      packageItemDec: window.g.VUE_APP_PACKAGE_ITEMDEC,
      additionalAutoadd: window.g.VUE_APP_ADDITIONAL_AUTOADD,//预约关联项目材料费附加费是否自动关联
      VUE_APP_ENABEL_SPECIFICDISEASE: window.g.VUE_APP_ENABEL_SPECIFICDISEASE,//是否开启专病套餐功能
      VUE_APP_AHEAD_DAY: window.g.VUE_APP_AHEAD_DAY,//提前预约天数
      VUE_APP_FESTIVAL: window.g.VUE_APP_FESTIVAL,
      isFestival: false,//是否是节日
      discountamount: 0,//优惠金额
      festivalTips: '已为您自动定位到最近可约日期',//节日提示
      showDate: false,
      minDate: new Date(),
      maxDate: new Date(),
      showTime: false,
      currentTime: '08:00',
      showTips: false,
      showSuccess: false,
      showDescription: false,//显示套餐说明
      userInfo: {},//个人信息
      relatives: [],//亲属信息
      radio: undefined,
      active: 0,
      active1: 0,
      checkedDate: undefined,
      checkDate: undefined,//预约体检时间
      checkedDateText: undefined,
      checkUser: {},//体检人信息
      orderCount: [],
      orderArr: new Array(),
      setBookedTime: [],//可约的时间段设置
      setBookedTimeSelected: undefined,
      setBookedTimeSelectedText: '',
      checkTotal: undefined,
      orderWeektime: [],
      showAdd: false,//增加项目
      showDel: false,//删除项目
      deptArr: [],//科室列表
      groups: [],//科室筛选后的组合列表
      datas: [],//所有组合项目
      checkDeptStr: '',//当前选择科室名称
      disableGroup: [],//组合，默认显示，默认禁止
      result: [],//已经选择了的项目ID
      delresult: [],//需要删除的项目ID
      excludeInfoList: [],//组合排斥关联
      checkedGroups: [],//加做项目已经选择了组合对象
      packagePrice: undefined,//已选套餐项目价格
      groupPrice: 0,//已选加做组合价格
      total: 0,//加做项目合计金额

      //用户信息编辑部分
      phoneErrorMessage: '',//手机号格式错误
      passwordErrorMessage: '',//密码由6位以上的数字与字符组成
      idcardErrorMessage: '',//身份证号码不正确
      date: '',
      areaCode: '',
      areaList,
      showAge: false,
      showNative: false,
      birthMinDate: new Date(1900, 0, 1),
      birthMaxDate: new Date(),
      param: {
        name: '',
        sexid: '',
        marital: '',
        phone: '',
        password: '',
        cardid: '',
        birthdate: '',
        address: '',
        // natives: '',//出生地Patient表没有
      },
      phoneDisabled: true,
      type: 'editSelf',
      editUserShow: false,
      chargeWrapperShow: false,  //订单层
      chargeWrapperData: null,
      overayShow: false, //轮询层
      currentRate: 0,//环形初始值
      initRate: 10, //环形初始目标值
      circleText: "10%", //环形文字
      qrCodeUrl: 'http://www.baidu.com',
      ermsg: '长按二维码支付',
      qrImageUrl: require("@/assets/images/WeChatPay.svg"),
      showSpecificDisease: false,//显示专病套餐
      specificDiseaseDetail: {},//专病套餐详情
      specificDiseaseDetailTitle: '',//专病套餐详情标题
      specificDiseaseDetailShow: false,
      VUE_APP_SETTLEMENTMODE: window.g.VUE_APP_SETTLEMENTMODE, //结算方式 默认按套餐
      defaultPackageList: [],//全部个人套餐数据
      SpecificDiseaseList: [],//专病套餐
      //小球
      ball: {
        el: null,
        show: false,
        imgSrc: require("@/assets/images/package/package-default.jpg")
      },
      showCheckedPackages: false,
      selfAmount: 0,
      checkLine: '1',
      configJson: {},//统一下单返回数据
      openid: '',
      payLoading: false,
      // 预约成功后提示框是否显示返回列表按钮
      answerShow: false,
      // 控制是否显示前往答题的弹框
      goAnswerPopShow: window.g.VUE_APP_GO_ANSWER_POP_SHOW,
      bookedNo: '',
      popIsQuestionOrOrder: true,//显示是否前往填写问卷调查
      typeid: '07',//问卷类型id
      isSubmitting: false,//是否在提交预约
      // 组合项目列表
      groupList: [],
      // 同意书弹框
      agreementShow: window.g.VUE_APP_AGREEMENT_SHOW,
      // 同意书遮罩
      agreementCover: false,
      // 同意 协议类型 :妇科同意书
      agreementType: '2',
      // 同意书待保存数据
      agreementSave: null,
      // 乙肝三项
      agreementYGShow: window.g.VUE_APP_AGREEMENT_YG_SHOW,
      currentSecond: 1,//当前秒数
      endRate: 6.6,//当前环形进度百分比
      payRefreshLoading: false,
      timer: null,
      projectDetailShow: window.g.VUE_APP_PROJECT_DETAIL_SHOW,// 项目详情是否以弹窗显示
      questionnaireMust: window.g.VUE_APP_PRE_QUESTIONNAIRE_MUST, // 必填问卷
      flowChart: false,
      badgeImageUrl: '/image/hint/flowChart.jpeg', // 使用绝对路径
      flowChartISHOW: window.g.VUE_APP_ORDER_FLOW_POP,
    }
  },
  created() {
    //清除定时器
    if (!this.timer) {
      clearInterval(this.timer)
    }
    let _this = this;
    // 设置结算方式
    if ("5" != this.VUE_APP_SETTLEMENTMODE) {
      this.VUE_APP_SETTLEMENTMODE = "2"
    }

    //套餐ID
    let packageId = this.$route.query.packageId
    this.checkLine = this.$route.query.checkLine
    if (packageId == null || packageId == undefined || packageId == '') {
      this.$router.push({name: 'package'})
      return
    }
    this.checkTotal = this.$route.query.checkTotal
    this.getPackageDetail(packageId)
    this.getUserList()


    // this.creatQrCode()

    let loginuser = JSON.parse(localStorage.getItem("loginuser"))
    this.getQuestionnaireTypeID()
    // 查询判断是否可以答 检前问卷
    getQuestionIsTrueForPersonal({patientid: loginuser.patientid}).then(res => {
      if (res.data) {
        // 可以答题
        this.answerShow = true
      }
    }).catch(err => {
      console.log(err)
    })

  },
  methods: {
    creatQrCode() {
      if (this.qrCodeUrl) {
        let qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: this.ermsg, //可以是链接，也可以是文本
          width: 200, //二维码的宽度
          height: 200, //二维码的高度
          colorLight: "#ffffff", //二维码背景色
          colorDark: "#000000", //二维码前景色，以实现红码为例
          correctLevel: QRCode.CorrectLevel.H, //纠错等级
        });
      } else {
        this.$refs.qrCodeUrl.innerHTML = ""//当从新调用时把之前生成的二维码清空
        let qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: this.ermsg, //可以是链接，也可以是文本
          width: 200, //二维码的宽度
          height: 200, //二维码的高度
          colorLight: "#ffffff", //二维码背景色
          colorDark: "#000000", //二维码前景色，
          correctLevel: QRCode.CorrectLevel.H, //纠错等级
        });
      }
    },
    generateRandomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    jsApiPay(bookedno) {
      if (this.VUE_APP_ISWECHAT == "1") {
        let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
        this.openid = userinfo.openid
      }
      var vm = this
      if (this.VUE_APP_ISWECHAT == "1" && this.openid == '') {
        alert("缺少openid")
        return;
      }
      let total = parseFloat(this.selfAmount) * 100
      let params = {
        type: 'jsapi',//支付类型
        openid: this.openid,//公众号id
        total: total,//订单金额
        attach: bookedno,//回调通知原样传递参数
        description: this.packageDetail.packageName + '体检费',//商品描述信息

      }
      transactions(params).then(res => {
        let data = {
          appId: res.signMap.appId,//公众号id，必传
          nonceStr: res.signMap.nonceStr,//随机串，必传
          timeStamp: res.signMap.timeStamp,//时间戳，必传
          package: "prepay_id=" + res.prepay_id,//必传
          signType: res.signMap.signType,//微信签名方式
          paySign: res.signMap.paySign,//微信签名
        }
        // 下面是解决WeixinJSBridge is not defined 报错的方法
        if (typeof WeixinJSBridge === 'undefined') { // 微信浏览器内置对象。参考微信官方文档
          if (document.addEventListener) {
            setTimeout(function () {
              document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(data), false)
            }, 1000)

          } else if (document.attachEvent) {
            setTimeout(function () {
              document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(data))
              document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(data))
            }, 1000)
          }
        } else {
          console.log('准备调用微信支付')
          setTimeout(function () {
            vm.onBridgeReady(data)
          }, 1000)
        }
      }).catch(err => {
        Dialog.alert({
          message: "统一下单返回出错：" + err
        }).then(() => {

        })
      })
    },
    onBridgeReady(data) {
      console.log('调用微信支付WeixinJSBridge')
      console.log('参数', data)
      var vm = this
      WeixinJSBridge.invoke(
          'getBrandWCPayRequest', { // 下面参数内容都是后台返回的
            'appId': data.appId, // 公众号名称，由商户传入
            'timeStamp': data.timeStamp, // 时间戳
            'nonceStr': data.nonceStr, // 随机串
            'package': data.package, // 预支付id
            'signType': data.signType, // 微信签名方式
            'paySign': data.paySign // 微信签名
          },
          function (res) {
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              vm.currentSecond = 1
              vm.endRate = 6.6
              vm.payRefreshLoading = true
              vm.timer = setInterval(function () {
                setTimeout(() => {
                  vm.payStatusRefresh()
                }, 0)
              }, 1000)
              //支付成功后更新订单状态
              vm.$router.push('/orders')
            } else {
              Dialog.alert({
                message: res.err_msg === 'get_brand_wcpay_request:cancel' ? "已取消支付" : "支付失败" + res.err_msg
              }).then(() => {
                vm.$router.push('/orders')
              })
            }
          }
      )
    },
    //刷新支付状态
    payStatusRefresh() {
      let _this = this
      //定时器效果
      _this.currentSecond++
      _this.endRate = _this.endRate + 6.6
      if (_this.currentSecond > 15) {
        clearInterval(_this.timer)
        _this.payRefreshLoading = false
      }
      let params = {
        bookedno: encrypt(_this.bookedNo),
        isorder: true
      }
      getPayStatus(params).then(res => {
        if (res.data == "1") {
          _this.payRefreshLoading = false
          clearInterval(_this.timer)
          //支付成功后更新订单状态
          _this.$nextTick(() => {
            _this.getOrders()
          })
        }
      })
    },
    //跳转小程序支付
    toMpAppPay() {
      this.$router.push({name: 'jumpMpApp'})
    },
    //查询预约排班
    getCount(checkLine) {
      var _this = this;
      let params = {
        companyid: "0000",
        companytimes: 1,
        checkline: checkLine == null ? "1" : checkLine,
        institutionid: window.g.VUE_APP_INSTITUTIONID
      }
      getOrderCount(params).then(res => {
        if (res.code == 200) {
          this.orderCount = res.data
          let currDatetime = ""
          let currDatetimeIsCount = false
          //定义一个变量，提前预约天数
          let nextDay = _this.getNow();
          console.log(nextDay)
          for (let i = 0; i < this.orderCount.length; i++) {
            let item = this.orderCount[i]
            this.orderArr.push(item.bookeddate + '')
            if (item.womennumber > 0 || item.mennumber > 0) {
              if (item.womennumber - item.alreadywomen > 0 || item.mennumber - item.alreadymen > 0) {
                if (!currDatetimeIsCount && item.bookeddate >= nextDay) {
                  currDatetime = item.bookeddate
                  currDatetimeIsCount = true
                  continue
                }
              }
            } else if (item.bookednumber > 0) {
              if (item.bookednumber - item.already > 0) {
                if (!currDatetimeIsCount && item.bookeddate >= nextDay) {
                  currDatetime = item.bookeddate
                  currDatetimeIsCount = true
                  console.log("currDatetime", currDatetime)
                  continue
                }
              }
            }
          }
          this.maxDate = this.getNextMonth()
          if (currDatetimeIsCount) {
            console.log("aaaa")
            _this.orderWeektime = _this.getWeekTime(currDatetime)
          } else {
            console.log("bbb")
            _this.orderWeektime = _this.getWeekTime()
          }
        }
      })
    },
    //查询预约时间段
    getSetBookedTime(bookedDate) {
      bookedDate = bookedDate.replace(RegExp("-", "g"), "")
      let params = {
        bookedDate: bookedDate,
        checkLine: this.checkLine,
        institutionId: window.g.VUE_APP_INSTITUTIONID
      }
      getSetBookedTime(params).then(res => {
        if (res.code == 200) {
          this.setBookedTime = res.data
        }
      })
    },
    //提交前去除重复项
    removeDuplicatesById(arr) {
      const ids = [];
      return arr.filter(obj => {
        if (ids.includes(obj.groupId)) {
          return false;
        }
        ids.push(obj.groupId);
        return true;
      })
    },
    makeOrder() {
      //判断性别是否符合
      if (this.packageDetail.sexId == '1') {
        //男
        if (this.checkUser.sexid == '0' || this.checkUser.sexid == '2') {
          Toast.fail('您选择的套餐与您选择的体检人性别不符合');
          return
        }
      } else if (this.packageDetail.sexId == '2') {
        //女
        if (this.checkUser.sexid == '0' || this.checkUser.sexid == '1') {
          Toast.fail('您选择的套餐与您选择的体检人性别不符合');
          return
        }
      }
      let chooseGroup = this.removeDuplicatesById(this.chooseGroup)
      this.chooseGroup = chooseGroup
      this.computeAmount()
      let groupIdList = []
      let prices = []
      let itemtypes = []
      this.checkedGroups.forEach(item => {
        prices.push(item.actualPrice)
        itemtypes.push(item.itemType)
      })
      let checkedPackages = this.checkedPackages
      //添加订单
      let param = {
        companyid: "0000",
        companytimes: 1,
        enterqueue: this.checkLine,
        itemmode: '3',
        settlementmode: this.VUE_APP_SETTLEMENTMODE,
        packageid: this.packageDetail.packageId,
        packagename: this.packageDetail.packageName,
        checkdate: this.checkDate,
        timeslot: this.setBookedTimeSelected,
        patientid: this.checkUser.patientid,
        amt: encrypt(this.selfAmount.toFixed(2)),
        amount: this.selfAmount.toFixed(2),
        discountamount: this.discountamount,//优惠金额
        packageamount: this.packageDetail.actualPrice,
        groupIdList: this.result,
        hospitaladdress: this.hospitalAddress,
        prices: prices,
        itemtypes: itemtypes,
        institutionid: window.g.VUE_APP_INSTITUTIONID,
        hisChargeOpen: this.hisChargeOpen,
        chooseGroup,
        checkedPackages,
        param: {
          name: '',
          sexid: '',
          marital: '',
          phone: '',
          password: '',
          cardid: '',
          birthdate: '',
          address: '',
          // natives: '',//出生地Patient表没有
        },
        phoneDisabled: true,
        type: 'editSelf',
        agreementSave: this.agreementSave,
        referralcode: localStorage.getItem("referralcode")
      }
      this.isSubmitting = true
      addOrder(param).then(res => {
        this.isSubmitting = false
        if (res.code == 200) {

          console.log("res.data.deptCestriction", res.data.deptCestriction)
          if (res.data.deptCestriction) {
            Dialog.alert({
              title: '温馨提示',
              message: res.data.deptCestriction,
            })
          }
          localStorage.removeItem("referralcode") // 清空推荐码
          if (res.data.bookedno == null || res.data.bookedno == 0) {
            //不能预约的情况
            Dialog.alert({
              title: '温馨提示',
              message: res.msg,
            })
            return;
          }
          // 解密添加bookedNo 如果开启了HIS收费则返回的流水号是res.data.serialno
          if (!res.data.serialno) {
            this.bookedNo = decrypt(res.data.bookedno)
          }

          if (this.VUE_APP_PAY_ENABLE) {
            //跳转支付链接
            if (this.VUE_APP_PAY_TYPE == "0") {
              Dialog.confirm({
                title: '提示',
                message: '已生成订单，请立即支付完成预约后请于 ' + this.checkDate + ' 携带身份证前往 ' + this.hospitalAddress + ' 进行体检。',
                confirmButtonText: '立即支付',
                cancelButtonText: '稍后再付'
              })
                  .then(() => {
                    this.payLoading = true
                    this.toPayPage(res.data.bookedno)
                  })
                  .catch((err) => {
                    Toast("已取消支付")
                    //支付成功后更新订单状态
                    this.$router.push('/orders')
                  });
            }
            //JSAPI调起支付
            else if (this.VUE_APP_PAY_TYPE == "2") {
              Dialog.confirm({
                title: '提示',
                message: '已生成订单，请立即支付完成预约后请于 ' + this.checkDate + ' 携带身份证前往 ' + this.hospitalAddress + ' 进行体检。',
                confirmButtonText: '立即支付',
                cancelButtonText: '稍后再付'
              })
                  .then(() => {
                    this.jsApiPay(this.bookedNo)
                  })
                  .catch((err) => {
                    Toast("已取消支付")
                    //支付成功后更新订单状态
                    this.$router.push('/orders')
                  });
            } else if (this.VUE_APP_PAY_TYPE == "3") {
              Dialog.confirm({
                title: '提示',
                message: '已生成订单，请立即支付完成预约后请于 ' + this.checkDate + ' 携带身份证前往 ' + this.hospitalAddress + ' 进行体检。',
                confirmButtonText: '跳转小程序完成支付'
              })
                  .then(() => {
                    this.toMpAppPay()
                  })
                  .catch((err) => {
                    Toast("已取消支付")
                    //支付成功后更新订单状态
                    this.$router.push('/orders')
                  });
            }
            //his收费
            else if (this.hisChargeOpen == "1") {
              //开启了his收费
              Dialog.confirm({
                title: '提示',
                message: '已生成订单，请立即支付完成预约后请于 ' + this.checkDate + ' 携带身份证前往 ' + this.hospitalAddress + ' 进行体检。',
                confirmButtonText: '立即支付',
                cancelButtonText: '稍后再付'
              })
                  .then(() => {
                    this.sendHis(res.data.serialno);
                  })
                  .catch((err) => {
                    Toast("已取消支付")
                    //支付成功后更新订单状态
                    this.$router.push('/orders')
                  });
            }
          } else {
            this.showSuccess = true
          }
        } else {
          //不能预约的情况
          Dialog.alert({
            title: '预约提交失败',
            message: res.msg,
          })
        }
      })
    },
    //跳转到支付页面
    toPayPage(bookedno) {
      let params = {
        bookedno: bookedno
      }
      getPaymentUrlByBookedNo(params).then(res => {
        if (res.code == 200) {
          window.location.href = res.data
        } else {
          this.payLoading = false
          Toast.fail("支付失败，" + res.data)
        }
      })
    },
    getOrderMain(serialno) {
      let param = {
        serialno: serialno,
        institutionid: window.g.VUE_APP_INSTITUTIONID
      }
      getOrderMain(param).then(res => {
        if (res.code == 200) {
          if (res.data == null) {
            Dialog.alert({
              title: '温馨提示',
              message: res.msg,
            }).then(() => {
            });
          } else {
            this.chargeWrapperShow = true
            res.data.httpstr = decodeURIComponent(res.data.httpstr)
            this.chargeWrapperData = res.data
          }
        }
      })
    },
    sendHis(serialno) {
      let param = {
        serialno: serialno
      }
      sendHis(param).then(res => {
        if (res.code == 200) {
          if (res.data == null) {
            Dialog.alert({
              title: '温馨提示',
              message: res.msg,
            }).then(() => {
            });
          } else {
            //显示轮询窗口
            this.showTips = false
            this.overayShow = true
            let inter = setInterval(() => {
              if (this.initRate < 100) {
                this.currentRate = this.initRate
                this.initRate = this.initRate + 10
                this.circleText = this.initRate + "%"
              } else {
                clearInterval(inter);
                this.overayShow = false
                this.getOrderMain(serialno);
              }
            }, 1000)
          }
        }
      })
    },
    checkInfo() {
      // 判断是否弹出流程图提示
      if (!this.flowChart) {
        this.flowChart = true
      }

      if (this.checkDate == undefined) {
        Toast.fail('请选择体检时间');
        return
      }
      if (this.setBookedTime.length > 0 && this.setBookedTimeSelected == undefined) {
        Toast.fail('请选择体检时间段');
        return
      }

      //获取体检人信息
      //radio,身份证号码,根据身份证号码确定是哪个体检人员
      if (this.radio == this.userInfo.cardid) {
        //本人
        this.checkUser = this.userInfo
      } else {
        //亲属
        this.relatives.forEach(item => {
          if (item.cardid == this.radio) {
            this.checkUser = item
          }
        })
      }

      if (this.checkUser.sexid == null || this.checkUser.sexid == undefined || this.checkUser.sexid == "" || this.checkUser.sexid == "0"
          || this.checkUser.cardid == null || this.checkUser.cardid == undefined || this.checkUser.cardid == ""
      ) {
        Dialog.alert({
          message: "信息不全，检查性别和身份证设置，请先补全基本信息再预约",
        }).then(() => {
          this.$router.push({name: 'edituser'})
        });
        return;
      }

      this.showTips = true
    },
    formatDate(date) {
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return `${year}-${month}-${day}`;
    },
    selectDate(date) {
      // 2024-02-28 修复
      let flag = false
      this.orderWeektime.some(item => {
        if (item.date === this.formatDate(date) && item.type) {
          flag = true
          return true;
        }
      })
      if (flag) {
        return;
      }

      let newDate = new Date()
      this.showDate = false
      // if(this.formatDate(date) == this.formatDate(new Date())){
      //   return;
      // }
      this.checkDate = this.formatDate(date)
      this.checkedDateText = this.checkDate
      this.setBookedTimeSelected = undefined
      this.orderWeektime = this.getWeekTime(this.checkDate)
      this.getSetBookedTime(this.checkDate)

      // 获取当前日期的套餐信息
      this.computeAmount()
    },
    setBookedTimeClick(item) {
      if (item.surplus > 0) {
        this.setBookedTimeSelected = item.id
        this.checkedDateText = this.checkDate + " " + item.starttime + "~" + item.endtime
      }
    },
    selectWeekDate(item) {
      if (item.type) {
        return;
      }
      console.log(item.date);
      this.checkDate = item.date
      this.checkedDateText = this.checkDate
      this.setBookedTimeSelected = undefined
      this.$refs.allDate.reset(new Date(this.checkDate));
      this.getSetBookedTime(this.checkDate)


      //套餐ID
      let packageId = this.$route.query.packageId
      this.getPackageDetailForFesdtival(item)
    },
    showTimeActionSheet() {
      this.showTime = true;
      this.currentTime = this.getNowHours();
    },
    getUserList() {
      let _this = this
      this.show = true
      //查询客户和亲属信息
      let param = {
        patientid: this.$encruption(JSON.parse(localStorage.getItem("loginuser")).patientid)
      }
      getRelatives(param).then(res => {
        //2025-07-03 luotong 处理PatientID加密出错导致的出错
        if(res.data == -1 && res.msg === "参数patientid错误"){
          Dialog({
            message: "登录过期，返回重新登录",
            theme: 'round-button',
          }).then(() => {
            window.localStorage.removeItem("loginuser")
            localStorage.removeItem("token")
            this.$router.push({name: 'login'})
          });
        }
        if (res.code == 200) {
          if (res.data == -1) {
            Dialog({
              message: res.msg + ',请立即联系体检中心处理，电话：' + this.hospitalPhone,
              theme: 'round-button',
            });
          } else {
            this.relatives = res.data
            if (this.radio == this.userInfo.cardid) {
              //本人
              this.checkUser = this.userInfo
            } else {
              //亲属
              this.relatives.forEach(item => {
                if (item.cardid == this.radio) {
                  this.checkUser = item
                }
              })
            }
            this.getGroups()
          }
        }
      })
      getUserInfoByPatientid(param).then(res => {
        if (res.code == 200) {
          if (res.data == -1) {
            if (res.msg == "参数patientid错误") {
              Dialog({
                message: "登录过期，返回重新登录",
                theme: 'round-button',
              }).then(() => {
                window.localStorage.removeItem("loginuser")
                localStorage.removeItem("token")
                this.$router.push({name: 'login'})
              });
            } else {
              Dialog({
                message: res.msg + ',请立即联系体检中心处理，电话：' + this.hospitalPhone,
                theme: 'round-button',
              });
            }
          } else {
            this.userInfo = res.data
            if (this.userInfo.cardid == null || this.userInfo.cardid == undefined || this.userInfo.cardid == '') {
              Toast.fail('请您完善个人信息！');
              this.param = this.userInfo
              this.param.name = decrypt(this.param.name)
              if (this.param.cardid != null) {
                this.param.cardid = decrypt(this.param.cardid)
              }
              this.param.phone = decrypt(this.param.phone)
              if (this.param.birthdate) {
                this.param.birthdate = this.param.birthdate.substring(0, 10)
              }
              this.editUserShow = true
            } else {
              this.radio = this.userInfo.cardid
              //本人 checkUser 赋值
              this.checkUser = this.userInfo
            }
          }
        }
      })
    },
    //获取套餐详情
    getPackageDetail(packageId) {
      let _this = this
      getPackageDetialByPackageId({packageId: packageId}).then(res => {
        if (res.code == 200) {
          _this.packageDetail = res.data
          _this.checkedPackages.push(res.data)
          _this.selfAmount = _this.packageDetail.actualPrice
          if (_this.packageDetail != null) {
            if (_this.packageDetail.basicGroupInfos != undefined) {
              _this.total = _this.packageDetail.basicGroupInfos.length
            }
            this.getCount(_this.packageDetail.checkLine)
          }
        } else {
          Toast.fail('服务器出错！');
        }
      })
    },
    //获取套餐详情
    getPackageDetailForFesdtival(dayObj) {
      let _this = this
      //判断当前选择的日期是否是节日，如果是，则打折
      let festival = _this.VUE_APP_FESTIVAL
      if (festival && festival.length > 0) {
        let isFestival = false
        for (let i = 0; i < festival.length; i++) {
          console.log("dayObj:" + JSON.stringify(dayObj))
          if (festival[i].date == dayObj.date && festival[i].open == true
              && new Date(festival[i].startdate) <= new Date(dayObj.date)) {
            let texts = festival[i].packagetext.split(",")
            if (texts && texts.length > 0) {
              for (let j = 0; j < texts.length; j++) {
                for (let k = 0; k < _this.checkedPackages.length; k++) {
                  if (_this.checkedPackages[k].packageName.includes(texts[j]) && _this.checkedPackages[k].sexId == festival[i].sex) {
                    _this.checkedPackages[k].price = _this.checkedPackages[k].actualPrice
                    _this.checkedPackages[k].actualPrice = _this.checkedPackages[k].actualPrice * festival[i].discount
                    this.discountamount = _this.checkedPackages[k].actualPrice - _this.checkedPackages[k].price
                    _this.checkedPackages[k].isDiscounted = true
                    isFestival = true
                    this.festivalTips = "选择在该日【" + festival[i].name + "】体检，享" + festival[i].discount * 10 + "折优惠"
                    break
                  }
                }
              }
            }
            break
          }
        }
        if (!isFestival) {
          for (let k = 0; k < _this.checkedPackages.length; k++) {
            if (_this.checkedPackages[k].isDiscounted) {
              _this.checkedPackages[k].actualPrice = _this.checkedPackages[k].price
              _this.checkedPackages[k].isDiscounted = false
            }
          }
          this.discountamount = 0
          this.festivalTips = "已为您自动定位到最近可约日期"
        }
      }
      _this.$nextTick(() => {
        this.computeAmount()
      })

    },
    detail(item) {
      if (item != '') {
        Dialog.alert({
          title: '检查意义',
          message: item,
        }).then(() => {
        });
      }
    },
    toCheckInfo() {
      this.$router.push({name: 'orders'})
    },
    getQuestionnaireTypeID() {
      let params = {
        typename: "体检检前问卷"
      }
      getQuestionnaireTypeID(params).then(res => {
        if (res.code == 200) {
          this.typeid = res.data
        }
      })
    },
    toPreconsultation() {
      if (this.answerShow && this.goAnswerPopShow) {
        let packageId = this.$route.query.packageId
        let loginuser = JSON.parse(localStorage.getItem("loginuser"))
        this.$router.push({
          name: 'preconsultationDetail',
          query: {
            id: null,
            serialno: null,
            bookedNo: loginuser.cardid,
            typeid: this.typeid,
            pageName: "packageDetail",
            pageParams: packageId
          }
        })
      } else {
        this.toCheckInfo()
      }
    },
    formatter(day) {
      let year = day.date.getFullYear();
      let month = day.date.getMonth() + 1;
      let date = day.date.getDate();
      if (month < 10) {
        month = '0' + month
      }
      if (date < 10) {
        date = '0' + date
      }
      let days = year + '-' + month + '-' + date
      this.orderCount.forEach(item => {
        if (item.bookeddate == days) {
          //节日文案显示
          if (month == 5 && date == 12) {
            day.topInfo = '母亲节';
          }
          if (month == 6 && date == 16) {
            day.topInfo = '父亲节';
          }
          if (item.status == '0') {
            day.bottomInfo = '不可约';
            day.type = "disabled"
          } else if (item.status == '1') {
            let personCount = 0;
            if (parseInt(item.mennumber) > 0 || parseInt(item.womenmumber) > 0) {
              if (this.userInfo.sexid == "1") {
                personCount = parseInt(item.mennumber) - parseInt(item.alreadymen);
              }
              if (this.userInfo.sexid == "2") {
                personCount = parseInt(item.womennumber) - parseInt(item.alreadywomen);
              }
            } else {
              personCount = parseInt(item.bookednumber) - parseInt(item.already);
            }
            if (personCount <= 0) {
              day.bottomInfo = '已约满';
              day.type = "disabled"
            } else {
              if (days < this.getNow()) {
                day.type = "disabled"
                day.bottomInfo = '不可约';
              } else {
                day.bottomInfo = '余 ' + personCount;
              }
            }
          }
        }
      })
      //将所有的没有排期的设置为休息日

      if (!this.orderArr.includes(days)) {
        let nextMonthStr = ""
        let nextMonth = this.getNextMonth()
        let nextM = nextMonth.getMonth() + 1
        let nextD = nextMonth.getDate()
        if (nextM < 10) {
          nextM = '0' + nextM
        }
        if (nextD < 10) {
          nextD = '0' + nextD
        }
        nextMonthStr = nextMonth.getFullYear() + '-' + nextM + '-' + nextD
        //已经过去的时间不显示文字
        if (days >= this.getNow() && days <= nextMonthStr) {
          day.bottomInfo = '不可约';
          day.type = "disabled"
        }
      }
      return day;
    },
    getNowHours() {
      let currentDate = new Date();
      let hours = currentDate.getHours();
      let seconds = currentDate.getMilliseconds();
      return hours + ":" + seconds;
    },
    onClick(name) {
      if (name == '0') {
        this.active = 0
      } else if (name == '1') {
        this.active = 1
        this.checkedGroups = []
        this.groupPrice = 0
        //加做组合
        let groups;
        groups = this.result.filter(item => {
          return !this.disableGroup.includes(item)
        })
        //获取加做组合详情 chooseGroup
        this.datas.forEach(item => {
          groups.forEach(jtem => {
            if (item.groupId == jtem) {
              this.checkedGroups.push(item)
              //加做组合价格 groupPrice
              this.groupPrice = parseFloat(this.groupPrice) + parseFloat(item.actualPrice)
            }
          })
        })
      } else if (name == '2') {
        this.active = 2
      } else if (name == '3') {
        this.active = 3
      }
    },
    getNextMonth() {
      let d = new Date();
      d.setMonth(d.getMonth() + 2);//月份只显示当前月，如果要显示下一月+1
      d.setDate(d.getDate() - 1);
      let yy1 = d.getFullYear();
      let mm1 = d.getMonth();
      let dd1 = d.getDate();
      return new Date(yy1, mm1, dd1)
    },
    getNow() {
      let d = new Date();
      d.setDate(d.getDate() + 1)
      if (this.VUE_APP_AHEAD_DAY != null) {
        d.setDate(d.getDate() + (parseInt(this.VUE_APP_AHEAD_DAY) - 1))
      }
      let yy1 = d.getFullYear();
      let mm1 = d.getMonth() + 1;
      if (mm1 < 10) {
        mm1 = '0' + mm1
      }
      let dd1 = d.getDate();
      if (dd1 < 10) {
        dd1 = '0' + dd1
      }
      console.log(yy1 + '-' + mm1 + '-' + dd1)
      return yy1 + '-' + mm1 + '-' + dd1
    },
    getNow2() {
      let d = new Date();
      let yy1 = d.getFullYear();
      let mm1 = d.getMonth() + 1;
      if (mm1 < 10) {
        mm1 = '0' + mm1
      }
      let dd1 = d.getDate();
      if (dd1 < 10) {
        dd1 = '0' + dd1
      }
      return yy1 + '-' + mm1 + '-' + dd1
    },
    getWeekTime(dateParam) {
      var new_Date = new Date() //获取本周一周日期
      if (this.orderArr.length > 0) {
        new_Date = new Date(this.orderArr[0])
      }
      if (dateParam != undefined) {
        new_Date = new Date(dateParam)
      }
      var timesStamp = new_Date.getTime();
      var currenDay = new_Date.getDay();
      var dates = [];
      for (var i = 0; i < 7; i++) {
        var das = new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7));
        // var dasStr = das.toLocaleDateString();
        let year = das.getFullYear();
        let month = das.getMonth() + 1;
        let date = das.getDate();
        if (month < 10) {
          month = '0' + month
        }
        if (date < 10) {
          date = '0' + date
        }
        let days = year + '-' + month + '-' + date
        var weekObj = {};
        weekObj.index = i
        weekObj.date = days;
        // das.replace(/[年月]/g, '.').replace(/[日上下午]/g, '');
        weekObj.day = (das.getMonth() + 1) + '/' + das.getDate();
        weekObj.week = this.getWeekName(das.getDay());
        weekObj.type = true;
        weekObj.number = '不可约'
        if (das.getDay() == 6 || das.getDay() == 0) {
          weekObj.type = true;
          weekObj.number = '不可约'
        }
        if (this.orderArr.length > 0) {
          this.orderCount.forEach(item => {
            if (item.bookeddate == days) {
              if (item.status == '0') {
                weekObj.number = '不可约'
                weekObj.type = true
              } else if (item.status == '1') {
                let personCount = 0;
                if (parseInt(item.mennumber) > 0 || parseInt(item.womennumber) > 0) {
                  if (this.userInfo.sexid == "1") {
                    personCount = parseInt(item.mennumber) - parseInt(item.alreadymen);
                  }
                  if (this.userInfo.sexid == "2") {
                    personCount = parseInt(item.womennumber) - parseInt(item.alreadywomen);
                  }
                } else {
                  personCount = parseInt(item.bookednumber) - parseInt(item.already);
                }
                if (personCount <= 0) {
                  weekObj.number = '已约满';
                  weekObj.type = true
                } else {
                  if (days < this.getNow()) {
                    weekObj.type = true
                    weekObj.number = '不可约';
                  } else {
                    weekObj.type = false
                    weekObj.number = '余 ' + personCount;
                    weekObj.isFestival = this.getIsFestival(days);
                    weekObj.festivalName = this.getFestivalName(days);
                  }
                }
              }
            }
          })
        }
        dates.push(weekObj);
      }
      return dates;
    },
    getIsFestival(days) {
      let isFestival = false;
      let festivalArr = this.VUE_APP_FESTIVAL;
      if (festivalArr && festivalArr.length > 0) {
        for (let i = 0; i < festivalArr.length; i++) {
          if (festivalArr[i].date == days && festivalArr[i].open == true
              && new Date(festivalArr[i].startdate) <= new Date(days)) {
            isFestival = true
            break
          }
        }
      }
      return isFestival
    },
    getFestivalName(days) {
      let festivalName = '';
      let festivalArr = this.VUE_APP_FESTIVAL;
      if (festivalArr && festivalArr.length > 0) {
        for (let i = 0; i < festivalArr.length; i++) {
          if (festivalArr[i].date == days && festivalArr[i].open == true
              && new Date(festivalArr[i].startdate) <= new Date(days)) {
            festivalName = festivalArr[i].name
            break
          }
        }
      }
      return festivalName
    },
    getWeekName(day) {
      switch (day) {
        case 1: {
          return "周一";
          break;
        }
        case 2: {
          return "周二";
          break;
        }
        case 3: {
          return "周三";
          break;
        }
        case 4: {
          return "周四";
          break;
        }
        case 5: {
          return "周五";
          break;
        }
        case 6: {
          return "周六";
          break;
        }
        case 0: {
          return "周日";
          break;
        }
        default: {
          return "";
        }
      }
    },
    //增加项目
    plusItem() {
      this.showAdd = true
    },
    //获取所有项目
    getGroups() {
      let param = {}
      getGroupInfoList(param).then(res => {
        if (res.code == 200) {
          this.groupList = res.data
          //根据科室进行分类
          this.datas = res.data
          res.data.forEach(item => {
            if (this.deptArr.length > 0) {
              if (!this.deptArr.includes(item.departmentName) && item.departmentName != undefined) {
                this.deptArr.push(item.departmentName)
              }
            } else {
              if (item.departmentName != undefined) {
                this.deptArr.push(item.departmentName)
              }
            }
          })
          res.data.forEach(item => {
            if (item.departmentName == (this.deptArr)[0]) {
              this.groups.push(item)
              this.checkDeptStr = item.departmentName
            }
          })
          this.getExcludes()
          this.checkDept(this.checkDeptStr)
        }
      })
    },
    //切换科室
    checkDept(name) {
      this.groups = []
      this.checkDeptStr = name
      //根据科室名称过滤组合
      this.datas.forEach(item => {
        if (item.departmentName == name) {
          this.groups.push(item)
          this.checkSex()
        }
      })
    },
    checkGroup(groupId, groupName) {
      if (/(?=.*?液基)(?=.*?TCT)/.test(groupName) || groupName.indexOf("HPV") != -1 || groupName.indexOf("妇科") != -1 || groupName.indexOf("阴道分泌物") != -1) {
        //判断是选择还是取消
        if (this.result.includes(groupId)) {
          Dialog.confirm({
            title: '温馨提示',
            message: '没有性生活史禁止检查',
          })
              .then(() => {
                // on confirm
                this.checkGroupAfter(groupId, groupName)
              })
              .catch(() => {
                // on cancel
                this.result.splice(this.result.findIndex(n => n === groupId), 1)
              });
        } else {
          this.checkGroupAfter(groupId, groupName)
        }
      } else {
        this.checkGroupAfter(groupId, groupName)
      }
    },
    //加做项目，选择项目
    checkGroupAfter(groupId, groupName) {
      //是否禁用
      if (this.disableGroup.includes(groupId)) {
        return;
      }
      //刷新加做组合
      this.checkedGroups = []
      let groups;
      groups = this.result.filter(item => {
        return !this.disableGroup.includes(item)
      })
      //已选加做组合变量赋值 checkedGroups
      this.datas.forEach(item => {
        groups.forEach(jtem => {
          if (item.groupId == jtem) {
            this.checkedGroups.push(item)
          }
        })
      })
      //排斥项目
      //1、this.packageDetail.basicGroupInfos //套餐项目
      //根据组合ID查询该组合的排斥项目
      let exclude = this.excludeInfoList.filter(item => {
        return item.groupId == groupId
      }).map(jtem => jtem.excludeGroupList)[0]

      if (exclude != undefined) {
        exclude.forEach(i => {
          this.checkedPackages.forEach(cp => {
            cp.basicGroupInfos.forEach(j => {
              if (i.relationGroupId == j.groupId) {
                Dialog.alert({
                  title: '项目冲突',
                  message: '不能添加，该项目【' + groupName + '】与已选套餐项目【' + j.groupName + '】互相排斥',
                }).then(() => {
                  // on close
                });
                this.result.splice(this.result.findIndex(n => n === groupId), 1)
                return;
              }
            })
          })

        })
      }
      //2、this.result //选择的加做项目
      if (exclude != undefined) {
        exclude.forEach(i => {
          this.checkedGroups.forEach(j => {
            if (i.relationGroupId == j.groupId) {
              Dialog.alert({
                title: '提示',
                message: '不能添加，该项目【' + groupName + '】与已选加做项目【' + j.groupName + '】互相排斥',
              }).then(() => {
                // on close
              });
              this.result.splice(this.result.findIndex(n => n === groupId), 1)
              return;
            }
          })
        })
      }

      //2、关联项目
      //根据组合ID查询该组合的关联项目
      //判断是选择还是取消
      //选择
      let relationAdd = ''
      let depend = this.excludeInfoList.filter(item => {
        return item.groupId == groupId
      }).map(jtem => jtem.dependGroupList)[0]
      if (this.result.includes(groupId)) {
        if (depend != undefined) {
          depend.forEach(item => {
            //2024-12-18 luotong 增加是否是必选项目的判断
            if (!this.result.includes(item.relationGroupId) && item.mandatory == "1") {
              let packageRepeat = this.packageDetail.basicGroupInfos.filter(jtem => {
                //判断材料费附加费是否需要关联自动添加
                if (this.additionalAutoadd) {
                  return jtem.groupId == item.relationGroupId
                } else {
                  return jtem.groupId == item.relationGroupId && jtem.itemType != '8' && jtem.itemType != '9'
                }
              })

              if (packageRepeat.length <= 0) {
                relationAdd += item.relationGroupName + ','
                this.result.push(item.relationGroupId)
              }
            }
          })
        }

        if (relationAdd != '') {
          Dialog.alert({
            title: '提示',
            message: '该项目【' + groupName + '】有关联必选项目【' + relationAdd + '】，已为您添加',
          }).then(() => {
            // on close
          });
        }
        this.updateCheckedGroups()
      } else {
        //取消，提示将关联的项目也取消
        let relationDel = []
        let relationDelName = []
        if (depend != undefined) {
          depend.forEach(item => {
            //20250923 去掉非必选不会被关联删除； 删除强制关联项目会连带删除非必选项目
            if (this.result.includes(item.relationGroupId)) {
              relationDel.push(item.relationGroupId)
            }
          })
        }
        //查询当前被排除的组合项目ID是否强关联多个组合项目 是则剔除不允许删除
        relationDel = this.getExcludeInfoList(relationDel)
        if (relationDel.length > 0) {
          this.datas.forEach(item => {
            relationDel.forEach(jtem => {
              if (item.groupId == jtem) {
                relationDelName.push(item.groupName)
              }
            })
          })
          Dialog.confirm({
            title: '提示',
            message: '请注意，该项目【' + groupName + '】有关联必选项目【' + relationDelName.join(",") + '】，是否需要取消关联项目？',
          }).then(() => {
            // on confirm
            relationDel.forEach(item => {
              this.result.splice(this.result.findIndex(n => n === item.groupId), 1)
            })
            this.updateCheckedGroups()
          }).catch(() => {
            // on cancel
            //如果点击了取消则复选框需要选回去 20250923 ZLS 增加
            this.result.push(groupId)
          });
        } else {
          this.updateCheckedGroups()
        }
      }
    },
    // 查询当前被排除的组合项目ID是否强关联多个组合项目
    getExcludeInfoList(ExcludeArr) {
      console.log("关联项目id2", ExcludeArr)
      var ExcludeArrList = [];
      for (const ExcludeId in ExcludeArr) {
        this.chooseGroup.forEach(atem => {
          if (atem.groupId != ExcludeArr[ExcludeId]) {
            this.excludeInfoList.forEach(item => {
              if (item.groupId == atem.groupId) {
                console.log("关联项目id3", item.groupId, item)
                item.dependGroupList.forEach(jtem => {
                  // 筛选出当前组合项目ID 关联的组合项目ID并且在自选列表中
                  if (jtem.mandatory == "1" && jtem.relationGroupId == ExcludeArr[ExcludeId]) {
                    ExcludeArrList.push(jtem.relationGroupId)
                  }
                })
              }
            })
          }
        })
      }
      console.log("关联项目id4", ExcludeArrList)
      // 如果能匹配到多个则剔除 如果只有一个则保留
      if (ExcludeArrList.length > 1) {
        // 使用Map统计每个元素出现的次数
        const countMap = new Map();
        ExcludeArrList.forEach(id => {
          countMap.set(id, (countMap.get(id) || 0) + 1);
        });

        // 只保留出现次数为1的元素
        ExcludeArr = ExcludeArr.filter(item => {
          return countMap.get(item) === 1;
        });
      }
      return ExcludeArr
    },
    //刷新已选组合项目和加项总价
    updateCheckedGroups() {
      //刷新加做组合
      this.checkedGroups = []
      let groups;
      groups = this.result.filter(item => {
        return !this.disableGroup.includes(item)
      })
      //获取加做组合详情 chooseGroup
      this.datas.forEach(item => {
        groups.forEach(jtem => {
          if (item.groupId == jtem) {
            this.checkedGroups.push(item)
            //加做组合价格 groupPrice
            this.groupPrice = parseFloat(this.groupPrice) + parseFloat(item.actualPrice)
          }
        })
      })
      this.computeAmount()
    },
    //将不适用性别的组合禁用掉
    checkSex() {
      this.disableGroup = []
      //判断性别是否适用
      let userSex = this.userInfo.sexid
      if (userSex == "0") {
        //女
        //过滤男性组合
        this.groups.forEach(item => {
          if (item.sexId == '1' && item.sexId != '0') {
            this.disableGroup.push(item.groupId)
          }
        })
      } else if (userSex == "1") {
        //男
        //过滤女性组合
        this.groups.forEach(item => {
          if (item.sexId == '2' && item.sexId != '0') {
            this.disableGroup.push(item.groupId)
          }
        })
      }
      //将套餐内包含的项目禁用掉
      this.groups.forEach(item => {
        this.checkedPackages.forEach(cp => {
          cp.basicGroupInfos.forEach(jtem => {
            if (item.groupId == jtem.groupId) {
              this.disableGroup.push(item.groupId)
            }
          })
        })
      })
    },
    //获取关联排斥项目
    getExcludes() {
      let params = {
        sexid: this.checkUser.sexid
      }
      getExcludeInfoList(params).then(res => {
        if (res.code == 200) {
          this.excludeInfoList = res.data
        }
      })
    },
    //清空已选项目
    clearGroups() {
      Dialog.confirm({
        title: '提示',
        message: '您确定要清空已选加做项目吗？',
      }).then(() => {
        Toast('已清空已选加做项目');
        this.result = []
        this.checkedGroups = []
        this.computeAmount()
      }).catch(() => {
        // on cancel
      });
    },
    //查看已选加做项目
    showChecked() {
      this.checkedGroups = []
      this.groupPrice = 0
      if (this.result.length == 0) {
        Dialog.alert({
          title: '提示',
          message: '没有已选项目',
        }).then(() => {
          // on close
        });
      } else {
        this.showAdd = false
        this.active = 1
        //加做组合
        let groups;
        groups = this.result.filter(item => {
          return !this.disableGroup.includes(item)
        })
        //获取加做组合详情 chooseGroup
        this.datas.forEach(item => {
          groups.forEach(jtem => {
            if (item.groupId == jtem) {
              this.checkedGroups.push(item)
              //加做组合价格 groupPrice
              this.groupPrice = parseFloat(this.groupPrice) + parseFloat(item.actualPrice)
            }
          })
        })
      }
    },
    delGroup(groupId, groupName, actualPrice) {
      // 查询当前项目ID是否有关联项目  2024-7-11 ZLS 修改删除逻辑; 当前组合项目有关联项目 则把关联项目从自选列表中剔除
      let ExcludeArr = new Array()
      this.excludeInfoList.forEach(item => {
        item.dependGroupList.forEach(jtem => {
          // 筛选出当前组合项目ID 关联的组合项目ID并且在自选列表中
          if (jtem.relationGroupId === groupId && this.result.includes(jtem.groupID)) {
            ExcludeArr.push(jtem.groupID)
          }
        })
      })
      // 20250923 ZLS 删除逻辑修改 强制关联项目必须没有关联项目才能删除
      ExcludeArr = this.getExcludeInfoList(ExcludeArr)
      console.log("关联项目id", ExcludeArr)
      var ExcludeName = [];
      var actualPrice = parseFloat(actualPrice);
      this.groupList.forEach(item => {
        if (ExcludeArr.includes(item.groupId)) {
          ExcludeName.push(item.groupName)
          actualPrice += parseFloat(item.actualPrice)
        }
      })
      ExcludeArr.push(groupId)
      console.log("关联到的项目名称", ExcludeName)
      console.log("删除项目的总金额", actualPrice)
      Dialog.confirm({
        title: '删除提示',
        message: ExcludeName.length > 0 ? '您确认要删除 【' + groupName + '】 项目及关联项目 【' + ExcludeName.join(',') + '】 吗？' : '您确认要删除 【' + groupName + '】 项目吗？',
      }).then(() => {
        //删除加做项目
        ExcludeArr.forEach(jtem => {
          this.result.splice(this.result.findIndex(i => i === jtem), 1)
          this.checkedGroups = this.checkedGroups.filter(item => {
            return item.groupId != jtem
          })
        })

        this.groupPrice = parseFloat(this.groupPrice) - parseFloat(actualPrice)
        this.computeAmount()

      })
    },
    edit() {
      if (this.type == 'editSelf') {
        let opneid = ''
        let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
        if (userinfo) {
          opneid = userinfo.opneid
          if (opneid != '' && opneid != undefined) {
            this.param.opneid = opneid
          }
        }
        //身份证、手机号码、密码加密
        let newParam = JSON.parse(JSON.stringify(this.param))
        newParam.cardid = encrypt(newParam.cardid)
        newParam.phone = encrypt(newParam.phone)
        newParam.password = encrypt(newParam.password)
        editUserInfo(newParam).then(res => {
          if (res.code == 200) {
            if (res.data == -1) {
              Toast.fail(res.msg);
            } else {
              let param = this.param

              param.name = encrypt(this.param.name)
              param.cardid = encrypt(this.param.cardid)
              param.phone = encrypt(this.param.phone)

              localStorage.setItem("loginuser", JSON.stringify(param))
              Toast.success('修改成功！');
              this.$router.go(-1);//返回上一层
            }
          }
        })
      } else if (this.type == 'editRelative') {
        this.param.phone = '';
        this.param.password = '';
        //身份证、手机号码、密码加密
        let newParam = JSON.parse(JSON.stringify(this.param))
        newParam.patientid = encrypt(newParam.patientid)
        newParam.cardid = encrypt(newParam.cardid)
        newParam.phone = encrypt(newParam.phone)
        newParam.password = encrypt(newParam.password)
        editRelatives(newParam).then(res => {
          if (res.code == 200) {
            if (res.data == -1) {
              Toast.fail(res.msg);
            } else {
              Toast.success('修改成功！');
              this.$router.go(-1);//返回上一层
            }
          }
        })
      }
    },
    phonevalidate() {
      //手机号码校验 phoneErrorMessage
      // eslint-disable-next-line no-unreachable
      let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/
      if (!myreg.test(this.param.phone)) {
        this.phoneErrorMessage = '请填写正确的手机号码'
        return false;
      } else {
        this.phoneErrorMessage = ''
        return true;
      }
    },
    idvalidate() {
      //身份证校验
      // eslint-disable-next-line no-unreachable
      let myreg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!myreg.test(this.param.cardid)) {
        this.idcardErrorMessage = '请填写正确的身份证号码'
        return false;
      } else {
        this.idcardErrorMessage = ''
        return true;
      }
    },
    onSubmit() {
      if (this.idvalidate()) {
        this.edit()
      }
    },
    changeUser() {
      if (this.radio == this.userInfo.cardid) {
        //本人
        this.checkUser = this.userInfo
      } else {
        //亲属
        this.relatives.forEach(item => {
          if (item.cardid == this.radio) {
            this.checkUser = item
          }
        })
      }
    },
    //获取专病套餐
    getSpecificDiseaseList() {
      if (this.SpecificDiseaseList.length > 0) {
        return
      }
      console.log(this.checkUser)
      let param = {
        companyId: '0000',
        companyTimes: '1',
        checkline: this.checkLine,
        sexid: this.checkUser.sexid,
        marriage: this.checkUser.marital,
        packagetype: '02'
      }
      getPackageListByCompanyId(param).then(res => {
        if (res.code == 200) {
          this.$nextTick(() => {
            res.data.forEach(item => {
              item.price = decrypt(item.priceStr)
              item.actualPrice = decrypt(item.actualPriceStr)
            })
            this.SpecificDiseaseList = res.data
          })
        }
      })
    },
    //清除已选专病套餐
    clearSpecificDisease() {
      Dialog.confirm({
        title: '提示',
        message: '您确定要清空已选专病套餐吗？',
      }).then(() => {
        this.$nextTick(() => {
          let flt_checkedPackages = this.checkedPackages.filter((item) => {
            return item.packageType == '01'
          })
          this.checkedPackages = flt_checkedPackages
          this.SpecificDiseaseList.forEach(item => {
            if (item.packageType != '01') {
              item.isSelected = false
            }
            item.basicGroupInfos.forEach(gtem => {
              gtem.isDelete = '0'
            })
          })
          this.checkSex()
          this.computeAmount()
        })

      }).catch(() => {
        // on cancel
      });

    },
    deleteSpecificDisease(packageObj) {
      this.$nextTick(() => {
        let flt_checkedPackages = this.checkedPackages.filter((item) => {
          return item.packageType == '01' || item.packageId != packageObj.packageId
        })
        this.checkedPackages = flt_checkedPackages
        this.SpecificDiseaseList.forEach(item => {
          if (item.packageType != '01' && item.packageId == packageObj.packageId) {
            item.isSelected = false
            item.basicGroupInfos.forEach(gtem => {
              gtem.isDelete = '0'
            })
          }
        })
      })
    },
    showSpecificDiseasePop() {
      this.showSpecificDisease = true
      this.getSpecificDiseaseList()
    },
    //显示已选专病套餐
    showSpecificDiseaseChecked() {
      this.showCheckedPackages = true
    },
    //选择专病套餐
    checkSpecificDisease(item, event) {
      //套餐项目是否重复
      let repPackageGroup = this.isRepPackageGroup(item);
      if (repPackageGroup.length > 0) {
        let groupNames = []
        repPackageGroup.forEach(item => {
          groupNames.push(item.groupName)
        })
        Dialog.confirm({
          title: '套餐项目重复提示',
          message: '以下项目：\t\n' + groupNames.join(',') + '\r\n和已选的套餐项目重复了，是否继续？',
          confirmButtonText: '继续',
          confirmButtonColor: '#07c160'
        }).then(() => {
          this.checkPackageFn(item)
        }).catch(() => {
          //取消
        })
      } else {
        this.checkPackageFn(item)
      }
    },
    checkPackageFn(item) {
      this.packageamount = 0;
      let userSex = this.userInfo.sexid

      if (item.sexId == '1') {
        if (userSex == '0') {
          Toast("该套餐性别不符合")
          return
        }
      } else if (item.sexId == '2') {
        if (userSex == '1') {
          Toast("该套餐性别不符合")
          return
        }
      }

      if (item.packageType == "01") {
        Toast("基础套餐最多只能选一个")
        return
      }
      item.isSelected = true
      //设置小球对象是当前点击对象
      this.ball.el = event.target
      this.ball.show = true
      //设置小球的图片为套餐的图片
      this.ball.imgSrc = event.currentTarget.parentElement.firstElementChild.firstElementChild.firstElementChild.getAttribute('src')

      // this.checkedPackageIds.push(item.packageId)
      // this.checkedPackageNames.push(item.packageName)
      this.checkedPackages.push(item)
      this.computeAmount()
      this.$nextTick(() => {
        item.basicGroupInfos.forEach(item => {
          this.disableGroup.push(item.groupId)
        })
      })
    },
    isRepPackageGroup(currentCheckPackage) {
      let repGroupInfos = []
      this.checkedPackages.forEach((item, i) => {
        item.basicGroupInfos.forEach(gtem => {
          currentCheckPackage.basicGroupInfos.forEach(jtem => {
            if (gtem.groupId == jtem.groupId) {
              //已选套餐中有重复项目
              repGroupInfos.push(jtem)
            }
          })
        })
      })
      return repGroupInfos
    },
    //计算金额
    computeAmount() {
      //查看已经选择的组合
      this.chooseGroup = []
      this.groupPrice = 0
      //加做组合
      let groups;
      groups = this.result.filter(item => {
        return !this.disableGroup.includes(item)
      })
      //获取加做组合详情 chooseGroup
      this.datas.forEach(item => {
        groups.forEach(jtem => {
          if (item.groupId == jtem) {
            this.chooseGroup.push(item)
            //加做组合价格 groupPrice
            this.groupPrice = parseFloat(this.groupPrice) + parseFloat(item.actualPrice)
          }
        })
      })
      this.packageamount = 0
      let amount = 0
      let actualAmount = 0;
      let selfAmount = 0
      let unDiscountItems = []
      let discountItems = []
      let unDiscountPrice = 0
      let prevBasicGroupInfos = []
      let deductionAmount = 0
      this.checkedPackages.forEach((item, i) => {
        this.packageamount += parseFloat(item.actualPrice)
        item.basicGroupInfos.forEach(gtem => {
          if (i > 0) {
            prevBasicGroupInfos.forEach(jtem => {
              if (gtem.groupId == jtem.groupId) {
                gtem.isDelete = '2'
                deductionAmount += gtem.price
              }
            })
          }
          if (gtem.isDelete == "2") {

          } else {
            amount += gtem.price
          }

          if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
            discountItems.push(gtem)
          } else {
            unDiscountItems.push(gtem)
            unDiscountPrice += gtem.price
          }
        })
        prevBasicGroupInfos = prevBasicGroupInfos.concat(item.basicGroupInfos)
      })
      //套餐总金额

      this.packageamount = this.packageamount - deductionAmount
      this.deductionAmount = deductionAmount
      this.chooseGroup.forEach(item => {
        amount += item.price
        if (item.allowDiscount == "1") {
          discountItems.push(item)
        } else {
          unDiscountItems.push(item)
          unDiscountPrice += item.price
        }
      })
      this.selfAmount = this.packageamount
      if (amount != 0) {
        selfAmount = this.packageamount + (this.groupPrice)
        this.selfAmount = selfAmount
        actualAmount = selfAmount
        console.log('更新价格前：' + selfAmount)
        console.log('更新价格前：' + actualAmount)
        this.updatePackageGroupsPrice() //更新套餐项目实收价格
        this.floatingPackageGroupsPrice() //抹平套餐价差
      }
      this.amount = amount.toFixed(2)
      this.actualAmount = actualAmount

      console.log("原价金额：" + this.amount)
      console.log("实收金额：" + this.actualAmount)
      console.log("套餐金额：" + this.packageamount)
      console.log("加做金额：" + (this.groupPrice))
      console.log("自付金额：" + this.selfAmount)
      this.checkGroupsPrice() //验证项目实收价格
    },
    //更新套餐项目实收价格
    updatePackageGroupsPrice() {
      this.checkedPackages.forEach(item => {
        //计算每个套餐的实际折扣（去除不允许折扣项目的金额）
        let notAllowDiscountAmount = 0
        item.basicGroupInfos.forEach(gtem => {
          if (gtem.allowDiscount != "1" || gtem.isDelete == "2") {
            notAllowDiscountAmount += gtem.price
          }
        })
        let realDiscount = (item.actualPrice - notAllowDiscountAmount) / (item.price - notAllowDiscountAmount)
        //更新套餐内允许折扣项目的时候金额
        item.basicGroupInfos.forEach(gtem => {
          if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
            gtem.actualPrice = (gtem.price * realDiscount).toFixed(2)
          }
        })
      })
    },
    //抹平套餐价差
    floatingPackageGroupsPrice() {
      this.checkedPackages.forEach(item => {
        let actualAmount = 0;
        let notAllowDiscountAmount = 0
        let maxIndex = 0
        let maxPrice = 0
        item.basicGroupInfos.forEach((gtem, i) => {
          if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
            actualAmount += parseFloat(gtem.actualPrice)
            if (parseFloat(gtem.actualPrice) > maxPrice) {
              maxPrice = parseFloat(gtem.actualPrice)
              maxIndex = i
            }
          } else {
            notAllowDiscountAmount += parseFloat(gtem.price)
          }
        })
        if (actualAmount != parseFloat(item.actualPrice - notAllowDiscountAmount)) {
          let diff = parseFloat(item.actualPrice - notAllowDiscountAmount) - actualAmount
          let tempPrice = item.basicGroupInfos[maxIndex].actualPrice;
          item.basicGroupInfos[maxIndex].actualPrice = parseFloat(tempPrice) + diff
        }
      })
    },
    //验证项目实收价格
    checkGroupsPrice() {
      let actualAmount = 0
      this.checkedPackages.forEach((item, pi) => {
        item.basicGroupInfos.forEach((gtem, i) => {
          if (gtem.isDelete != "2") {
            actualAmount += parseFloat(gtem.actualPrice)
          }
        })
      })
      this.chooseGroup.forEach((item, i) => {
        actualAmount += parseFloat(item.actualPrice)
      })
      console.log("验证实收金额：" + actualAmount.toFixed(2))
    },
    showSpecificDiseaseDetail(paramPackage) {
      this.specificDiseaseDetailTitle = paramPackage.packageName
      //通过套餐ID查询套餐详情
      this.specificDiseaseDetailShow = true
      this.SpecificDiseaseList.forEach(item => {
        if (item.packageId == paramPackage.packageId) {
          this.specificDiseaseDetail = item
        }
      })
      this.$nextTick(function () {
        if (this.specificDiseaseDetail != null) {
          if (this.specificDiseaseDetail.basicGroupInfos != undefined) {
            // this.total = this.packageDetail.basicGroupInfos.length
          }
        }
      })
    },
    //小球飞入购物车特效
    beforeEnter(el) {
      let ele = this.ball.el //要添加购物车的商品
      let ract = ele.getBoundingClientRect() //商品的位置
      let elRight = this._getStyle(el, 'right') //购物车 right
      let elTop = this._getStyle(el, 'top') //购物车 top
      let x = ract.left - 300 // 计算小球移动的X轴的距离
      let y = window.innerHeight - ract.top - 30// 计算小球移动的y轴的距离

      el.style.display = ''
      el.style.transform = `translateX(${x}px)` //重置小球的x轴位置

      let innerBall = el.querySelector('.innerBall')
      innerBall.style.transform = `translateY(-${y}px)`//重置小球的y轴位置
    },
    enter(el, done) {
      let ele = this.ball.el //要添加购物车的商品
      let ract = ele.getBoundingClientRect() //商品的位置
      let x = ract.left // 计算小球移动的X轴的距离
      let y = window.innerHeight - ract.top - 100// 计算小球移动的y轴的距离
      this._offset = document.body.offsetHeight //激发重绘

      el.style.transform = `translateX(-${x}px)` //重置小球的x轴位置
      let innerBall = el.querySelector('.innerBall')
      innerBall.style.transform = `translateY(${y}px)`//重置小球的y轴位置
      el.addEventListener('transitionend', done)
    },
    afterEnter(el) {
      console.log("执行后")
      this.ball.show = false
      el.style.display = 'none'
    },
    _getStyle(el, attr) {
      return el.currentStyle
          ? el.currentStyle[attr]
          : getComputedStyle(el, false)[attr]
    },
    orderNow() {
      if (this.agreementShow || this.agreementYGShow) {
        this.showAgreement()
      } else {
        this.makeOrder()
      }
    },
    // 弹出同意书
    showAgreement() {
      this.agreementType = []
      console.log("组合项目：" + this.chooseGroup)
      if (this.FKAgreement() && this.agreementShow) {
        this.agreementType.push('2')
      }
      if (this.YGAgreement() && this.agreementYGShow) {
        this.agreementType.push('3')
      }
      let extend = this
      if (this.agreementType.length > 0) {
        Dialog.confirm({
          title: '温馨提示',
          message: '请签署同意书',
          confirmButtonText: '去签署',
          cancelButtonText: '取消预约'
        }).then(() => {
          extend.agreementCover = true
          console.log('fkFlag', extend.agreementCover)
        })
      } else {
        this.makeOrder();
      }
    },
    // 循环判断是否有乙肝三系项目
    YGAgreement() {
      let ygFlag = false;
      this.checkedPackages.forEach(item => {
        item.basicGroupInfos.forEach(gtem => {
          if (gtem.groupName.indexOf(this.agreementYGShow) != -1) {
            console.log("有需要签署同意书的乙肝三系套餐")
            ygFlag = true;
          }
        })
      })
      // 筛选乙肝三系
      this.chooseGroup.forEach(item => {
        if (item.groupName.indexOf(this.agreementYGShow) != -1) {
          console.log("有需要签署同意书的乙肝三系项目")
          ygFlag = true;
        }
      })
      return ygFlag
    },
    FKAgreement() {
      const user = JSON.parse(localStorage.getItem("loginuser"));
      if (user.sexid == '1') { // 如果性别是男性进
        return
      }
      if (user.marital !== '0' && user.marital != '3') {// 筛选婚姻状态 非未知和未婚状态都进入
        return
      }
      // 如果是已婚套餐不签署
      let fkFlag = true;
      // 判断套餐的婚姻状态
      let marriage = false
      this.checkedPackages.forEach(item => {
        if (item.marriage == '1') {
          fkFlag = false
        } else if (item.marriage == '2') {
          fkFlag = true
        } else {
          fkFlag = true
          marriage = true
        }
      })
      if (!fkFlag) {
        return
      }
      // 判断套餐的婚姻状态 为未知；没加项则不签署
      fkFlag = false;
      console.log("套餐无婚姻状态")
      // 筛选妇科项目
      this.chooseGroup.forEach(item => {
        if (item.gynaecology == "1") {
          console.log("有需要签署同意书的妇科项目")
          fkFlag = true;
        }
      })
      return fkFlag;
    },
    handleSignatureIdUpdate(agreementSave) {
      this.agreementCover = false
      this.agreementSave = agreementSave
      this.makeOrder();
    },
    showProjectDetail(item) {
      if (item == null || item == '') {
        return
      }
      //   弹窗提示
      Dialog.alert({
        title: '检查意义',
        message: item,
      }).then(() => {
        // on close
      });
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  background: #F5F5F5;
}

.name {
  width: 100%;
  display: flex;
  flex-flow: row;
  justify-content: center;
  background: #fff;
  padding: 20px 30px;
}

.group {
  padding-bottom: 10rem;
  height: calc(100vh - 81vw);
  overflow: scroll;
}

p {
  margin-top: 1.5rem;
}

.van-calendar__body {
  padding-bottom: 80px;
}


.plur-item-side {
  border-top-left-radius: 2rem;
}

.plur-item-main {
  border-top-right-radius: 2rem;
}

.plur-item-side .van-cell-group {
  background-color: #ecf1f5;
}

.plur-item-side .van-cell {
  background-color: transparent
}

.plur-item-side .van-cell-group.active {
  /*background-image: linear-gradient(to right, #10E3E9, #409EFF);*/
  background-color: #fff;
  color: #000;
  font-weight: bold;
  position: relative;
}

.plur-item-side .van-cell-group.active .van-cell {
  color: #000;
}

.plur-item-side .van-cell-group.active:before, .plur-item-side .van-cell-group.active:after {
  content: ' ';
  position: absolute;
  background: #ecf1f5;
  width: 1.2rem;
  height: 1.2rem;
  right: 0;
  z-index: 2;
  display: block;
}

.plur-item-side .van-cell-group.active:before {
  top: -1.2rem;
  border-bottom-right-radius: 100%;
}

.plur-item-side .van-cell-group.active:after {
  bottom: -1.2rem;
  border-top-right-radius: 100%;
}

.corner {
  width: 1.2rem;
  height: 1.2rem;
  position: absolute;
  background: #fff;
}

.bottom-corner {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1;
}

.top-corner {
  position: absolute;
  bottom: 100%;
  right: 0;
}

.plur-item-side .van-cell:after {
  border-bottom: none;
}

.plur-item-side .van-cell {
  color: #737171;
}

.van-popup {
  background-clip: padding-box;
}


.order-dates {
  background: #fff;
  margin-top: 0.5rem;
}

.order-dates dt {
  font-size: 2rem;
  font-weight: bold;
  padding: 1.5rem;
  display: flex;
  font-weight: 500;
}

.order-dates dt .dt-right {
  font-size: 2.2rem;
  color: #969799;
}

.order-dates dt h3 {
  flex: 1;
}

.order-dates h3 {

}

.order-dates dd {
  padding-bottom: 1.5rem;
}

.order-dates ul {
  display: flex;
  font-size: 1.6rem;
  margin-left: 1rem;
  margin-right: 1rem;
}

.order-dates ul li {
  flex: 1;
  margin: 0 .3rem;
  background: #f1f5f9;
  text-align: center;
  padding-bottom: 1rem;
  border-radius: 1.5rem;
}


.order-dates ul li p {
  margin-top: .5rem;
  margin-bottom: .5rem;
}

.order-dates ul .day {
  color: gray;
  position: relative;
}

.order-dates ul li .sup {
  position: absolute;
  right: 9px;
  width: 13px;
  color: #ff8917;
}

.order-dates ul .week {
  font-size: 2rem;
  font-weight: bold;
}

.order-dates ul li.disabled .day, .order-dates ul li.disabled .week, .order-dates ul li.disabled .number {
  color: #d0d0d0;
}

.order-dates ul li.active {
  background-color: #1989fa;
}

.order-dates ul li.active .day, .order-dates ul li.active .week, .order-dates ul li.active .number {
  color: #fff;
}

/*预约日期是小于等于当天的不能约*/
.order-dates ul li.actived {
  background-color: #d5e1f9;
}

.order-times {
  margin-top: .2em;
  font-size: 2em;
  background: #f7f8fa;
  padding: 0 1em 1em 1em;
}

.order-times h3 {
  padding: 1.5rem 0;
}

.pdr10 {
  padding-right: 1em;
  text-align: left;
  font-size: .8em
}

.overlay-in {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.overlay-in .overlay-text {
  padding: 2em;
  font-size: 2.4em;
  text-align: center;
}

.overlay-in .overlay-text h3 {
  font-size: 1.6em;
}

.overlay-interval {
  background-color: #ffffff;
}

/*二维码*/
#qqq {
  /* background-color: #111; */
  width: 300px;
  height: 300px;
  margin: 0 auto; /*水平居中*/
  position: relative;
}

.qrCode {
  display: inline-block;
  margin: 14px auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-100px, -100px);
}

.qrCode img {
  width: 200px;
  height: 200px;
  background-color: #fff;
  padding: 6px;
}

.vue-qr-code {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 220px;
}

.vue-qr-text {
  font-size: 3em;
}

.package-item {
  width: 100%;
  /*height: 12rem;*/
  background: #fff;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  display: flex;
  flex-flow: row;
  justify-content: center;
  /*box-shadow: 0 0 1.5rem #f5f5f5;*/
}

.package-group-list dl {
  padding: .5em .5em;
  line-height: 3.5em;
  margin: 1em 2em;
}

.package-group-list dl dt {
  color: #333;
  font-size: 2.2em;
}

.package-group-list dl dd {
  font-size: 2em;
  color: #999;
}

.package-group-list dt.text-decoration {
  text-decoration: line-through;
  color: #ff6c6c;
}

.van-goods-price {
  font-size: 2em;
  color: orangered;
  padding-left: .5em;
  padding-right: .5em;
}

.goods-price-text {
  color: #000
}

.goods-price-int {
  font-size: 2.1em;
}

/*小球*/
.ball {
  position: fixed;
  bottom: 40px;
  right: -140px;
  width: 2rem;
  height: 2rem;
  transition: all 1000ms cubic-bezier(0.000, 0.600, 0.940, 0.270);
  z-index: 9;
}

.innerBall {
  width: 2rem;
  height: 2rem;
  transition: all 1s linear;
}

/*套餐项目说明、自选项目说明*/
.van-cell__label {
  font-weight: normal;
  color: #aaa;
}

/* 项目说明：检查意义css */
.project_detal_show {
  display: flex;
  width: 20%;
  font-size: 26px;
  background-color: #ffffff;
  color: #a6a6a8;
  text-align: center;
  align-items: center;
  border-bottom: 3px solid #f5f5f5
}
</style>
